{
  "translation": {
    "ai_templates": {
      "menu_title_pet": "Haustierporträts",
      "menu_title_family": "Familienporträts",
      "menu_title_kids": "Kinder-Wandkunst",
      "menu_title_places": "Orte-Kunst",
      "menu_title_travel_posters": "Reiseposter",
      "menu_title_vintage_posters": "Vintage-Poster",
      "menu_title_home_hobbies": "Zuhause & Hobbys",
      "menu_title_kitchen_art": "Küchenkunst",
      "menu_title_food_drink_art": "Essen & Trinken",
      "menu_title_food_recipe_art": "Essen & Rezepte",
      "menu_title_travel": "Reisen",
      "kids_wall": {
        "child_name": "Name des Kindes",
        "interests_label": "Nenne 2-3 Dinge, die es liebt",
        "interests_placeholder": "z.B. Dinosaurier, Fußball, Einhörner",
        "interests_hint": "Keine Markenfiguren angeben"
      },
      "upload_menu": {
        "text_input_title": "Name des Haustiers (optional)",
        "create": "Erstellen",
        "processing": "Wird verarbeitet...",
        "upload_photo": "Foto hochladen",
        "cta": {
          "upload_pet_photo": "Haustierfoto hochladen",
          "upload_couple_photo": "Paarfoto hochladen",
          "upload_old_photo": "Altes Foto hochladen",
          "upload_photo_with_faces": "Foto mit Gesichtern hochladen",
          "upload_scenic_photo": "Landschaftsfoto hochladen",
          "upload_family_photo": "Familienfoto hochladen"
        }
      },
      "faces_selection": {
        "generate_button": "Fotos generieren ({{count}} {{label}})",
        "no_faces_detected": "Es wurden keine Gesichter erkannt",
        "people": "Personen",
        "pet": "Haustier",
        "pets": "Haustiere",
        "portraits": "Porträts",
        "person": "Person",
        "subtitle": "Achte darauf, dass die Gesichter klar sind und Augen und Haare sichtbar sind",
        "title": "Gesichter auswählen"
      },
      "multi_upload": {
        "cta": "1-9 Fotos hochladen",
        "title": "Für die besten Ergebnisse"
      },
      "results": {
        "add_tile": "Tile hinzufügen",
        "next": "Weiter"
      },
      "loading": {
        "creating_photos": "Fotos werden erstellt..."
      },
      "variations": {
        "generation_failed": "Dein neuer Stil konnte nicht erstellt werden. Bitte versuche es erneut.",
        "create_button_one": "{{count}} Porträt erstellen",
        "create_button_other": "{{count}} Porträts erstellen",
        "add_portraits_line_1": "Porträts hinzufügen",
        "add_portraits_line_2": "für",
        "add_portraits_for_pet": "Porträts für dein Haustier hinzufügen",
        "change_pet_photo": "Haustierfoto ändern",
        "back_to_add_options": "Zurück zu den Optionen",
        "load_failed": "Stile konnten nicht geladen werden. Bitte versuche es erneut.",
        "no_more_templates": "Keine weiteren Vorlagen für dein Haustier",
        "generating_snackbar": "Erstellen"
      },
      "errors": {
        "unexpected_error": "Bilderzeugung fehlgeschlagen",
        "safety_reject": "Bild aus Sicherheitsgründen abgelehnt",
        "service_unavailable": "Fehler: Dienst nicht verfügbar",
        "image_too_large": "Fehler: Bild zu groß",
        "image_processing_failed": "Fehler: Bild konnte nicht verarbeitet werden",
        "rate_limit": "Du hast das Anfragelimit für heute erreicht. Bitte versuche es morgen erneut."
      },
      "variants": {
        "boy": "Junge",
        "girl": "Mädchen"
      }
    },
    "art": {
      "collection": {
        "categories": {
          "Abstract": "Abstrakt",
          "Animals": "Tiere",
          "Beach": "Strand",
          "Best Sellers": "Bestseller",
          "Botanical": "Botanisch",
          "Classic Art": "Klassische Kunst",
          "Destinations": "Reiseziele",
          "Faith": "Glaube",
          "Famous Artists": "Berühmte Künstler",
          "Flowers": "Blumen",
          "Geometric": "Geometrisch",
          "Kids": "Kinder",
          "Kitchen": "Küche",
          "Lines": "Linien",
          "Mountains": "Berge",
          "Nature": "Natur",
          "Plants": "Pflanzen",
          "Sayings": "Sprüche",
          "Travel": "Reisen",
          "Urban": "Urban",
          "Dogs & Cats": "Hunde & Katzen"
        }
      },
      "home": {
        "cta_browse": "Kunstsammlung durchstöbern",
        "subtitle": "Kunst die man liebt, kinderleicht finden, rahmen und an die Wand bringen",
        "title": "Dekoriere Deine Wände in wenigen Minuten",
        "title_with_category": "Die {{v1}} Serie"
      },
      "select_art": "Kunstdrucke wählen"
    },
    "business": {
      "add_emails": "E-Mail-Adressen hinzufügen",
      "company_name": "Firmenname",
      "contact_form_title": "Fülle eben diesen Fragebogen aus und einer unserer Experten setzt sich mit Dir in Verbindung",
      "csv": "CSV hochladen",
      "desired_amount_of_tiles": "Gewünschte Anzahl an Bildern",
      "employees_gift_cards": "Mitarbeiter-Gutscheine",
      "employees_to_be_gifted": "Mitarbeiter, die beschenkt werden ",
      "gift_card_for_title": "Digitale Gutscheine, Mengenrabatt",
      "submit": {
        "subtitle": "Einer unserer Experten wird sich in Kürze bei Dir melden",
        "title": "Danke! Wir haben Deine Anfrage empfangen"
      },
      "subtitle": "Erlebe die Einfach- und Schönheit individueller Bilder. Unsere speziellen B2B-Pakete bieten Sonderrabatte und Expertenunterstützung.",
      "title": "Keine gewöhnlichen Firmengeschenke",
      "your_name": "Dein Name"
    },
    "centerpiece": {
      "add_wall_sign": "Hauptbild hinzufügen",
      "bottom_text": "TEXT UNTEN",
      "customize": "Personalisieren",
      "top_text": "TEXT OBEN"
    },
    "download_app": {
      "card": {
        "title": "Deine Galeriewand Ist Fertig!",
        "subtitle": "Unsere smarte App gestaltet beeindruckende Galeriewände aus deinen besten Fotos"
      },
      "hero": {
        "title": "Deine Fotobücher Sind Fertig!",
        "subtitle": "Unsere smarte App gestaltet beeindruckende Fotobücher aus deinen besten Fotos"
      },
      "cta": "App Herunterladen"
    },
    "collage": {
      "add_more": "Fotos hinzufügen um eine Collage zu erstellen",
      "collage": "Collage",
      "edit_collage": "Collage bearbeiten",
      "exceeding_photos": {
        "choose_photos_plural": "Wähle {{v1}} Bilder für dieses Layout",
        "choose_photos_singular": "Wähle 1 Bild für dieses Layout",
        "select_more_photos_plural": "Wähle {{v1}} weitere Fotos",
        "select_more_photos_singular": "Wähle 1 weiteres Foto"
      },
      "layout_rearrange_notice": "Dieser Schritt wird das Layout ändern",
      "text_limit_reached": "Du hast das Textlimit erreicht",
      "text_unsupported_size": "Ändere die Größe, um Text hinzuzufügen"
    },
    "designer": {
      "add_tile_or_collage_to_enable_bulk_editing": "Bild oder Collage hinzufügen um Mengenbearbeitung zu ermöglichen",
      "add_tile_to_enable_bulk_editing": "Bilder hinzufügen um Mengenrabatt zu bekommen",
      "adjust_crop_description": "Reinzoomen oder drüberwischen",
      "adjust_crop_description_desktop": "Scrollen um reinzuzoomen, klicken und ziehen um zu verschieben",
      "adjust_crop_hint": "Reinzoomen oder klicken und ziehen",
      "adjust_crop_hint_desktop": "Klicken und ziehen um den Bildausschnitt anzupassen",
      "bold": "Fett",
      "border": "Rand",
      "bulk_override_warning": {
        "apply_filter": "Filter hinzufügen",
        "apply_frame_color": "Rahmen hinzufügen",
        "apply_mat": "Rand hinzufügen",
        "apply_material": "Bildart wählen",
        "apply_size": "Größe wählen",
        "apply_to_all": "Auf alle anwenden",
        "title": "Soll diese Änderung für alle Bilder übernommen werden?"
      },
      "change_mat": "Wähle eine andere Umrandung um Farben angezeigt zu bekommen",
      "change_mat_notifications": {
        "disabled": "Verfügbar in anderen Rahmen",
        "partial_apply": {
          "generic_material_subtitle": "Einige Bilder sind nicht mit Rändern kompatibel",
          "single_material_subtitle": "{{v1}} nicht mit Rändern kompatibel",
          "title": "Ränder teilweise angewandt"
        }
      },
      "choose_swap": "Wähle ein Foto zum Tauschen",
      "classic": "Klassisch",
      "color": "Farbe",
      "crop": "Anpassen",
      "delete": "Löschen",
      "duplicate": "Duplizieren",
      "drop_files": "Zum Hochladen Fotos ablegen",
      "effect": "Effekt",
      "excellent_quality": {
        "cta": "Alles klar!",
        "subtitle": "Wir benachrichtigen Dich, sollte ein Problem auftreten",
        "title": "Hervorragende Fotoqualität!"
      },
      "frameless_8x8_caption": "Nur {{v1}}",
      "filter": "Filter",
      "frame": "Rahmen",
      "handwriting": "Handschrift",
      "layout": "Layout",
      "mat": "Rand",
      "material": "Bildart",
      "mixed_sizes": "Gemischte Größen",
      "out_of_stock_warning": {
        "approve": "Auf {{size}} ändern",
        "cancel": "{{material}} beibehalten",
        "title": "{{size}} {{material}} Bilder sind momentan nicht verfügbar",
        "out_of_stock": "Ausverkauft",
        "product_approve": "Zu {{product}} wechseln",
        "product_cancel": "Bei {{product}} bleiben",
        "product_title": "{{product}} sind nicht auf Lager"
      },
      "photos": "Fotos",
      "progress_bar": {
        "adding_photos": "Fotos werden hinzugefügt...",
        "framing_your_photos": "Wir rahmen Deine Bilder ein..."
      },
      "select_border": "Randeffekt wählen",
      "select_effect": "Effekt wählen",
      "select_filter": "Filter wählen",
      "select_frame": "Rahmen wählen",
      "select_frame_color": "Rahmenfarbe wählen",
      "select_layout": "Layout wählen",
      "select_mat": "Randeffekt wählen",
      "select_material": "Bildart auswählen",
      "select_size": "Größe wählen",
      "select_style": "Stil wählen",
      "select_text_style": "Schrift wählen",
      "size": "Größe",
      "swap_positions": "Position tauschen",
      "tile_deleted": "Bild gelöscht",
      "wide": "Breit",
      "bad_crop": {
        "approve_btn": "Bestätigen & Bestellen",
        "back_btn": "Zurück",
        "desktop_subtitle": "Scrollen zum Zoomen, ziehen zum Bewegen",
        "edit": "Gesamte Bestellung bearbeiten",
        "mobile_subtitle": "Zusammenziehen zum Zoomen, ziehen zum Bewegen",
        "next_btn": "Weiter",
        "review_btn": "Fotos überprüfen",
        "title": "Lass uns sicherstellen, dass deine Fotos nach deinen Wünschen zugeschnitten sind!"
      },
      "matting": "Passepartout",
      "recommended_size": "Empfohlen {{v1}} oder kleiner",
      "select_color": "Farbe wählen",
      "select_matting": "Passepartout wählen",
      "text": "Text"
    },
    "general": {
      "address_form": {
        "add_title": "Adresse eingeben",
        "change_save": "Bearbeiten",
        "change_title": "Adresse ändern",
        "form_fields": {
          "address": "Adresse",
          "address_2": "Adresszeile 2",
          "city": "Stadt",
          "country": "Land auswählen ",
          "full_name": "Name (Max Mustermann)",
          "full_name_kana": "Name in Katakana",
          "full_name_kana_placeholder": "Katakana-Lesung des Namens eingeben",
          "phone": "Telefonnummer",
          "postal": "Postleitzahl",
          "province": "Provinz",
          "state": "Bundesland",
          "state_or_province": "Provinz",
          "state_or_territory": "Bundesland",
          "zip": "Postleitzahl"
        },
        "phone_number_info": "Die Telefonnummer wird ausschließlich dazu benötigt um Dich zu kontaktieren, sollte es zu Lieferschwierigkeiten kommen.",
        "suggest_offers": "Exklusive Angebote per SMS und Messaging-App erhalten",
        "suggest_offers_email": "Für E-Mail-Updates zu exklusiven Angeboten anmelden",
        "re_enter_address": "Adresse neu eingeben",
        "use_this_address_anyway": "Diese Adresse trotzdem verwenden",
        "validation_errors": {
          "address": {
            "invalid": "Ungültige Stadt/Land/PLZ",
            "not_found": "Ungültige Adresse",
            "not_supported": "Ups, {{product}} Bestellungen sind hier derzeit noch nicht verfügbar. Tut uns Leid!"
          },
          "city_state": {
            "invalid": "Ungültige Stadt oder Land"
          },
          "country": {
            "unsupported": "Es tut uns Leid, aber dahin können wir derzeit nicht versenden."
          },
          "email": {
            "invalid": "Bitte gib eine gültige E-Mail-Adresse an"
          },
          "full_name": {
            "invalid": "Unvollständig. Gib bitte Vor- und Nachnamen ein."
          },
          "full_name_kana": {
            "missing": "Bitte gib die Kana-Lesung deines Namens ein",
            "invalid": "Die Lesung darf nur Hiragana oder Katakana enthalten"
          },
          "non_latin_characters": "Bitte verwende nur lateinische Buchstaben",
          "house_number": {
            "invalid": "Ungültige Hausnummer",
            "missing": "Hausnummer fehlt"
          },
          "missing_fields": {
            "general": "Bitte gib alle notwendigen Informationen an um fortzufahren",
            "specific": "Bitte gib Deine {{v1}} an um fortzufahren"
          },
          "name": {
            "invalid": "Gib bitte Vor- und Nachnamen ein",
            "too_long": "Name darf {{v1}} Zeichen nicht überschreiten"
          },
          "phone": {
            "invalid": "Bitte gib eine gültige Telefonnummer an"
          },
          "secondary_information": {
            "invalid": "Ungültiger Adresszusatz",
            "missing": "Adresszusatz fehlt"
          },
          "state": {
            "invalid": "Ungültiges Land"
          },
          "street": {
            "invalid": "Ungültiger Straßenname",
            "missing": "Straßenname fehlt",
            "po_box": "An Packstationen können wir leider nicht versenden"
          },
          "mind_another_look": "Schaust du nochmal drüber?",
          "zip": {
            "invalid": "Ungültige PLZ",
            "not_found": "Ungültige PLZ",
            "state_mismatch": "Postleitzahl und Ort stimmen nicht überein",
            "unsupported_territory": "Wir liefern nicht in diese Region"
          }
        }
      },
      "applied": "angewandt",
      "auto_save_message": "Dein Fortschritt wird zwischengespeichert",
      "best_seller": "Bestseller",
      "add": "Hinzufügen",
      "cancel": "Abbrechen",
      "credits": {
        "balance": "Du verfügst über {{v1}} Mixtiles Guthaben"
      },
      "discard_changes": "Änderungen verwerfen",
      "done": "Fertig",
      "each": "/Stück",
      "errors": {
        "dark_mode_subTitle": "Wechseln Sie in den Light Mode über die Systemeinstellungen, um die Farben lebensnah darzustellen.",
        "dark_mode_title": "Dark Mode verändert die Farben unserer Produkte.",
        "general_description": "Entschuldige bitte! Gib auf jeden Fall Bescheid, wenn das Problem weiter auftritt!",
        "general_description_short": "Bitte versuche es erneut",
        "general_title": "Irgendwas ist schief gelaufen...",
        "general_title_short": "Etwas ist schief gelaufen",
        "order_cancelled_title": "Bestellung Storniert",
        "order_cancelled_refund_subtitle": "Die Rückerstattung wird bearbeitet",
        "webgl_not_supported_subtitle": "Öffne diese Seite in Safari oder Chrome, um diese Vorschau zu sehen.",
        "webgl_not_supported_title": "Diese Vorschau kann in diesem Browser nicht angezeigt werden"
      },
      "from_price": "Ab {{v1}}",
      "gdpr_dialog": {
        "privacy_policy": "Datenschutzerklärung",
        "terms_of_use": "AGB"
      },
      "got_it": "Alles klar",
      "languages": {
        "change_language": "Sprache ändern",
        "de": "Deutsch",
        "en": "English",
        "es": "Español",
        "fr": "Français",
        "ja": "日本語",
        "language": "Sprache"
      },
      "menu": {
        "accessibility_button": "Barrierefreiheit",
        "add_promo_code": {
          "modal": {
            "form_title": "Gib Deinen Code hier ein:",
            "placeholder": "Promo Code",
            "title": "Promocode eingeben",
            "title_with_gift_card": "Promocode oder Geschenkgutschein eingeben"
          },
          "success": {
            "code_applied": "{{v1}} eingelöst"
          }
        },
        "art_collection": "Kunstsammlung",
        "buy_gift_card": "Geschenkgutschein kaufen",
        "chat_with_us": "Starte einen Chat",
        "cookie_policy": "Cookie-Richtlinie",
        "faq": "FAQ",
        "for_business": "Firmengeschenke",
        "frame_your_photos": "Style Deine Fotos",
        "gift_card": "Kaufe einen Gutschein",
        "gift_card_v2": "Geschenkgutschein",
        "help_center": "Hilfe-Center",
        "my_orders": "Meine Bestellungen",
        "privacy_policy": "Datenschutzerklärung",
        "promo_code_manager": {
          "promo_codes": "Promocodes"
        },
        "use_code_to_save": "Code '{{v1}}' anwenden und bis zu {{v2}}% sparen. Der Rabatt variiert je nach Größe und Material."
      },
      "new": "Neu",
      "ok": "OK",
      "optional": "Optional",
      "payment_form": {
        "header": "Rechnungsadresse",
        "same_shipping_address": "Rechnungs- und Lieferanschrift sind gleich",
        "validation_errors": {
          "address": {
            "missing": "Bitte gib Deine komplette Adresse an um fortzufahren"
          },
          "missing_fields": {
            "general": "Bitte gib Deine Zahlungsinformationen an um fortzufahren"
          }
        }
      },
      "promo_code_selector": {
        "default": "standard",
        "disclaimer": "Der Rabatt variiert je nach Größe und Material.",
        "free_tile_description": "{{v1}} kostenlose {{v2}} Bilder",
        "free_book_description": "{{v1}} kostenlose {{v2}} Fotobücher",
        "free_tiles": "Gratisbilder",
        "free_books": "Kostenlose Fotobücher",
        "promo_not_applied_to_product": "Dieser Gutschein gilt nicht für {{v1}}",
        "select_volume_discount": "Mengenrabatt wählen",
        "volume_discount_applied": "Mengenrabatt eingelöst",
        "gift_card_description": "{{v1}} Guthaben ({{v2}} verfügbar)"
      },
      "promo_code_success_dialog": {
        "call_to_action": "Jetzt Shoppen",
        "save_message_on_product": "{{v1}} Rabatt auf {{v2}}",
        "save_up_to_message_shortened": "Spare bis zu {{v1}}%",
        "size_and_material_disclaimer": "Spare bis zu {{v1}}%. Der Rabatt variiert je nach Größe und Material.",
        "subtitle": {
          "gift_card": "Du hast {{v1}} erfolgreich hinzugefügt",
          "gift_card_tiles_many": "{{v1}} Gratisbilder",
          "gift_card_tiles_one": "ein Gratisbild",
          "gift_card_books_many": "{{v1}} Gratis-Fotobücher",
          "gift_card_books_one": "ein Gratis-Fotobuch"
        },
        "title": {
          "bundle": "{{v1}}{{size_constraint}} Bilder für {{v2}}",
          "free_tiles_many": "Du hast {{v1}} Gratisbilder{{size_constraint}}!",
          "gift_card": "Geschenkkarte eingelöst!"
        }
      },
      "refresh": "Aktualisieren",
      "skip": "Später",
      "start_creating": "Los gehts!",
      "continue_design": "Design fortsetzen",
      "talk_to_us": "Schreib uns",
      "try_again": "Nochmal probieren",
      "learn_more": "Mehr erfahren"
    },
    "google_photos": {
      "authorize_title": "Mit Google Fotos verbinden",
      "authorize": "Anmelden",
      "select_title": "Google Fotos in neuem Tab öffnen um Fotos auszuwählen",
      "select_photos": "Im neuen Tab",
      "error_title": "Fehler",
      "error_message": "Irgendetwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
      "try_again": "Erneut versuchen",
      "fetching_title": "Fotos werden geladen",
      "step_1": "Schritt 1",
      "step_2": "Schritt 2",
      "adding_photos": "Füge Fotos hinzu...",
      "google_photos_requires_safari": "Google Fotos muss in Safari geöffnet werden",
      "open_safari": "In Safari öffnen",
      "stay_here": "Hier bleiben",
      "disconnect": "Von Google Fotos trennen"
    },
    "get_started": {
      "form_fields": {
        "email": "E-Mail-Adresse"
      },
      "title": "Lass uns loslegen"
    },
    "gift_card": {
      "books": "Bücher",
      "buy_now": "Bestellen",
      "delivered_by_email_with_expiry": "Diese Geschenkkarte wird per E-Mail verschickt und verfällt nicht.",
      "form": {
        "add_email_address": "E-Mail-Adresse angeben",
        "card_value_label": "Gutscheinwert auswählen",
        "choose_book_size": "Buchgröße wählen",
        "custom_placeholder": "Individuell",
        "design_label": "Design auswählen",
        "gift_message_label": "Persönliche Nachricht (optional)",
        "gift_message_placeholder": "Persönliche Nachricht hinzufügen",
        "gift_scheduler_label": "Wann soll der Gutschein versendet werden?",
        "now": "Sofort",
        "recipient_email_placeholder": "E-Mail-Adresse des Empfängers",
        "recipient_label": "Wer wird beschenkt?",
        "sender_label": "Von wem ist der Gutschein?",
        "sender_name_placeholder": "Name des Schenkenden",
        "today": "Heute"
      },
      "number_of_books": "{{v1}} Bücher, {{v2}}",
      "number_of_tiles": "{{v1}} Bilder",
      "prepay_save_up_to": "Im Voraus zahlen und bis zu {{v1}}% sparen",
      "prepay_save_exact": "Im Voraus zahlen und {{v1}}% sparen",
      "sizes_note_2": "Nur für {{v1}} gerahmt oder ungerahmt erhältlich.",
      "switch_gift_card_type_cta": "Wechseln Sie",
      "switch_to_tile_based_description": "zu unserer anderen Geschenkkarte - wählen Sie nach der Anzahl der Bilder oder Bücher, die Sie verschenken möchten",
      "switch_to_value_based_description": "zu unserer regulären Geschenkkarte, bei der Sie mit dem gewünschten Geldbetrag einkaufen können. Diese Geschenkkarten gelten für alle Größen und Materialien.",
      "tiles": "Bilder",
      "title_digital": "Digitaler Geschenkgutschein",
      "your_email": "Deine E-Mail-Adresse"
    },
    "holidays": {
      "arrives_before_christmas": "Lieferung vor Weihnachten",
      "arrives_before_fathers_day": "Lieferung pünktlich zum Vatertag",
      "arrives_before_mothers_day": "Lieferung pünktlich zum Muttertag",
      "arrives_before_valentines_day": "Lieferung vor dem Valentinstag",
      "arrives_before_veterans_day": "Lieferung vor dem Veterans Day",
      "get_it_by_christmas": "Bis Weihnachten erhalten",
      "get_it_by_fathers_day": "Bis zum Vatertag erhalten",
      "get_it_by_mothers_day": "Bis zum Muttertag erhalten",
      "get_it_by_valentines_day": "Bis zum Valentinstag erhalten",
      "get_it_by_veterans_day": "Bis zum Veterans Day erhalten"
    },
    "homepage": {
      "photo_books_banner": {
        "subtitle": "Bekannt aus dem TV,\nJetzt bestellen",
        "cta": "Ausprobieren"
      },
      "beauty": {
        "subtitle": "Jedes Buch kommt mit einem matten Einband und Premium-Seiten mit seidigem Finish",
        "title": "Jede Seite ein Grund zur Freude",
        "design_subtitle": "Ein einzigartig gestaltetes Hardcover für jede Reise, mit Premium-Druck und seidenmatten Seiten für eine zeitlose Sammlung",
        "design_title": "Zum Sammeln Gestaltet",
        "life_events_subtitle": "Ein wunderschön gefertigtes Hardcover, mit Premium-Druck und seidenmatten Seiten für eine Sammlung, die Du für immer schätzen wirst",
        "life_events_title": "Zum Sammeln Gestaltet"
      },
      "chat": {
        "content": "Unser Support Team steht Dir jeden Tag von 7 Uhr morgens - 12 Uhr abends EST zur Verfügung",
        "cta": "Starte einen Chat",
        "title": "Können wir helfen?"
      },
      "community": {
        "subtitle_black_frames": "Schwarze {{v1}} Rahmen ",
        "subtitle_white_frames": "Weiße {{v1}} Rahmen",
        "subtitle_wood_frames": "Holzfarbene {{v1}} Rahmen",
        "subtitle_wood_mixed_frames": "Holzrahmen in gemischten Größen",
        "title": "Aus unserer Community"
      },
      "cookies_choices": "Deine Datenschutz-Einstellungen",
      "covered": {
        "rated": "Bewertet mit {{v1}}",
        "rated_subtitle": "{{v1}} + App Store Bewertungen",
        "reviews": "Bewertungen",
        "shipping": "Schneller, kostenloser Versand",
        "shipping_free_subtitle": "ohne Mindestbestellwert",
        "shipping_subtitle": "Kostenloser Versand für Bestellungen über {{v1}}",
        "support": "Engagierter Kundendienst",
        "support_short": "Engagierter Support",
        "support_subtitle": "Echte Menschen, die bereit sind Euch zu helfen",
        "title": "Wir lassen Dich nie hängen",
        "trustpilot": "Auf Trustpilot mit „Ausgezeichnet“ bewertet"
      },
      "faq": {
        "frames": {
          "content": "Die Formate starten bei {{v1}} und gehen bis {{v2}}. Unsere einzigartigen Hauptbilder sind {{v3}} groß. Erhältlich in verschiedenen Materialien und Rahmenfarben, einschließlich rahmenloser Optionen und Leinwänden.",
          "title": "Wie groß sind die Bilder?"
        },
        "frames-art": {
          "content": "Die Formate starten bei {{v1}} und gehen bis {{v2}}. Erhältlich in verschiedenen Materialien und Rahmenfarben, einschließlich rahmenloser Optionen und Leinwänden.",
          "title": "Wie groß sind die Bilder?"
        },
        "move-tiles": {
          "content": "Kinderleicht! Sie sind dafür gemacht, sich mehrfach umpositionieren zu lassen, ohne die Wände dabei zu beschädigen.",
          "title": "Lassen sich die Bilder wirklich so einfach umkleben?"
        },
        "photo-books-customize": {
          "content": "Mühelos, natürlich! Unser einzigartiges Layout, mit einem Foto pro Seite, garantiert, dass jede Erinnerung Ihren Rampenlicht-Moment bekommt. Personalisiere Dein Fotobuch, indem Du das perfekte Foto für das Cover auswählst und einen Titel hinzufügst. Mit nur wenigen Klicks kannst Du  Fotos hinzufügen, zentrieren, und die Reihenfolge bestimmen, damit das Fotobuch Deine ganz persönliche Geschichte erzählt.",
          "title": "Wie kann ich mein Fotobuch individuell gestalten?"
        },
        "photo-books-delivery": {
          "content": "In der Regel dauert es vom Zeitpunkt der Bestellung ca. {{delivery_time}}, bis Dein Fotobuch bei Dir ankommt. Natürlich wird Dir der voraussichtliche Liefertermin an der Kasse, vor Bestellabschluss, noch einmal angezeigt. Die Lieferung erfolgt per UPS, und das völlig kostenlos! ",
          "title": "Wie lange dauert es, bis ich mein Fotobuch erhalte?"
        },
        "photo-books-discount": {
          "content": "Gute Frage! Da Fotobücher ganz neu in unserem Sortiment sind, gelten die meisten unserer Mixtiles-Rabatte noch nicht. Anders ist es mit Mixtiles-Guthaben oder Geschenkkarten - die können auch beim Kauf von Fotobüchern verwendet werden!",
          "title": "Ich habe einen Rabatt für Mixtiles erhalten. Gilt der auch für Fotobuch Bestellungen?"
        },
        "photo-books-material": {
          "content": "Unsere Fotobücher sind ausschließlich als Hardcover erhältlich und versprechen Langlebigkeit mit jedem Umblättern! Der Einband ist mit einer dünnen, matten Folie versehen, während die Fotos auf samtig-seidenem, holzfreiem Papier gedruckt werden, welches die Farben intensiviert und nicht störend reflektiert. Zudem sind unsere Fotobücher recycelbar!",
          "title": "Woraus sind die Bücher gemacht?"
        },
        "photo-books-shipment": {
          "content": "Wir liefern derzeit in die USA, nach Kanada, Großbritannien, in die EU und nach Australien – wir hoffen, in naher Zukunft weitere Länder hinzufügen zu können!",
          "title": "Wohin liefert ihr?"
        },
        "photo-books-size": {
          "content": "Fotobücher sind derzeit in drei Größen erhältlich: {{v1}} für {{v1_price}}, {{v2}} für {{v2_price}}, und {{v3}} für {{v3_price}}. Der Preis bleibt immer gleich, ganz egal wie viele Fotos hinzugefügt werden. Jedes Fotobuch umfasst mindestens 25 und maximal {{max_photos}} Deiner liebsten Schnappschüsse.",
          "title": "In welchen Größen sind Fotobücher erhältlich?"
        },
        "photo-books-size-tiers": {
          "content": "Fotobücher sind in drei praktischen Größen erhältlich: {{v1}} ab {{v1_price}}, {{v2}} ab {{v2_price}} und {{v3}} ab {{v3_price}}. Jede Größe hat drei einfache Preisstufen je nach Seitenzahl: bis zu 40, bis zu 120 und bis zu 200 Seiten. Jedes Fotobuch benötigt mindestens 25 Fotos und kann bis zu {{max_photos}} Deiner liebsten Erinnerungen enthalten.",
          "title": "In welchen Größen sind Fotobücher erhältlich?"
        },
        "photo-books-wedding-size": {
          "content": "Das Mixtiles-Hochzeitsfotobuch gibt es in den Größen {{v1}}, {{v2}} und {{v3}}. So findest du das perfekte Format, um die kostbaren Erinnerungen an euren großen Tag zu bewahren.",
          "title": "Welche Größe sollte ich für mein Hochzeitsfotobuch wählen?"
        },
        "photo-books-wedding-paper": {
          "content": "Bei Mixtiles soll dein Hochzeitsalbum ewig halten. Deshalb verwenden wir samtiges Papier mit seidenähnlichem Griff und einen Hardcover-Einband mit matter Oberfläche – für Haltbarkeit und einen professionellen Look.",
          "title": "Welches Papier eignet sich für ein Hochzeitsfotobuch?"
        },
        "photo-books-wedding-pages": {
          "content": "Die Seitenzahl hängt davon ab, wie viele Fotos du einbinden möchtest und wie detailliert das Buch sein soll. Ein guter Startpunkt sind 20–40 Seiten – umfassend, aber dennoch kompakt.",
          "title": "Wie viele Seiten sollte ein Hochzeitsfotobuch haben?"
        },
        "photo-books-wedding-durability": {
          "content": "Ein hochwertig produziertes Hochzeitsalbum kann bei richtiger Lagerung viele Jahre halten und Erinnerungen für kommende Generationen bewahren. Bewahre es vor direktem Sonnenlicht und Feuchtigkeit, um die Lebensdauer zu erhöhen.",
          "title": "Wie lange hält ein gedrucktes Hochzeitsalbum?"
        },
        "photo-books-wedding-vs-traditional": {
          "content": "Ein Hochzeitsfotobuch ist eine moderne, schlanke Art, eure Erinnerungen zu zeigen. Mit einem Ein-Klick-Erstellungsprozess werden Fotos automatisch auf Seiten angeordnet und sind sofort bestellbereit. Du kannst die Reihenfolge bei Bedarf anpassen.",
          "title": "Warum ein Hochzeitsfotobuch statt eines traditionellen Albums?"
        },
        "photo-books-memory-what-is": {
          "content": "Ein Foto-Erinnerungsbuch ist eine schön gebundene Sammlung von Bildern, die deine wertvollen Momente festhält. Es eignet sich für Familienfeiern, Urlaube oder besondere Ereignisse. Mit Mixtiles gestaltest du ein persönliches Erinnerungsbuch, das deine Geschichte erzählt.",
          "title": "Was ist ein Foto-Erinnerungsbuch und wofür nutzt man es?"
        },
        "photo-books-memory-create": {
          "content": "Mit Mixtiles erstellst du dein Erinnerungsbuch einfach und intuitiv: Lade mindestens 24 Fotos hoch und wähle bis zu {{max_photos}} Bilder aus. Ordne, zoome und schneide sie bequem zu. Pro Seite gibt es ein Foto – so kommt jede Erinnerung zur Geltung. Bestellen kannst du über Website oder App.",
          "title": "Wie erstelle ich ein Foto-Erinnerungsbuch?"
        },
        "photo-books-memory-occasions": {
          "content": "Erinnerungsbücher passen zu vielen Anlässen: Hochzeiten, Geburtstage, Jubiläen, Abschlüsse, Feiertage – oder als einfühlsames Gedenkbuch für geliebte Menschen.",
          "title": "Für welche Anlässe eignen sich Erinnerungsbücher?"
        },
        "photo-books-memory-custom": {
          "content": "Mit einem individuellen Erinnerungsbuch ordnest du deine Fotos genau in der Reihenfolge, die deine Geschichte am besten erzählt. Mixtiles Bücher auf samtigem, seidenähnlichem Papier und mit mattem Hardcover sind elegant und langlebig.",
          "title": "Warum ein individuelles Foto-Erinnerungsbuch erstellen?"
        },
        "photo-books-memory-pages": {
          "content": "Mixtiles Erinnerungsbücher können bis zu {{max_photos}} Seiten umfassen – jeweils mit einem Foto pro Seite. So bekommt jedes Bild die Aufmerksamkeit, die es verdient.",
          "title": "Wie viele Seiten kann ein Foto-Erinnerungsbuch haben?"
        },
        "photo-books-memory-cover": {
          "content": "Unsere Erinnerungsbücher haben ein schlankes, mattes Hardcover – robust und elegant. Du kannst eine besondere Titelfoto wählen und den Text personalisieren. Die Rückseite bleibt fotofrei für einen klaren Look.",
          "title": "Welche Cover-Optionen gibt es für Erinnerungsbücher?"
        },
        "photo-books-memory-cost": {
          "content": "Die Kosten hängen von Größe und Seitenzahl ab. Exakte Preise findest du in unserer Website oder App.",
          "title": "Was kostet ein Foto-Erinnerungsbuch?"
        },
        "photo-books-memory-easiest": {
          "content": "Am einfachsten erstellst du dein Erinnerungsbuch mit der benutzerfreundlichen Mixtiles Plattform. Website und App bieten intuitive Tools zum Hochladen, Anordnen und Bearbeiten. Unser Support hilft per Live-Chat oder E-Mail.",
          "title": "Was ist der einfachste Weg, ein Erinnerungsbuch zu erstellen?"
        },
        "photo-books-small-sizes": {
          "content": "Wir bieten drei Größen: {{v1}} ({{v1_dimensions}}), {{v2}} ({{v2_dimensions}}) und {{v3}} ({{v3_dimensions}}). {{v1}} ist perfekt als kleines Fotobuch – kompakt und elegant.",
          "title": "Welche Größen haben kleine Fotobücher?"
        },
        "photo-books-small-why-choose": {
          "content": "Ein kleines Fotobuch ist handlich und platzsparend – ideal als persönliches Andenken oder Geschenk. Trotz kleiner Größe: Premium-Materialien und brillante Farben bleiben erhalten.",
          "title": "Warum ein kleines statt eines großen Fotobuchs?"
        },
        "photo-books-small-occasions": {
          "content": "Kleine Fotobücher eignen sich für Familienmomente, Reisen oder besondere Meilensteine. Auch für Themenreihen wie Haustier-Highlights oder das erste Babyjahr sind sie perfekt.",
          "title": "Für welche Anlässe eignen sich kleine Fotobücher?"
        },
        "photo-books-small-pages": {
          "content": "Kleine Mixtiles Fotobücher fassen 24 bis {{max_photos}} Seiten, mit einem Foto pro Seite – kompakt und dennoch umfassend.",
          "title": "Wie viele Seiten hat ein kleines Fotobuch?"
        },
        "photo-books-small-customizable": {
          "content": "Auf jeden Fall! Mit Mixtiles kannst du Fotos anordnen, zoomen und zuschneiden. Außerdem: Titelfoto wählen und individuellen Text hinzufügen.",
          "title": "Sind kleine Fotobücher anpassbar?"
        },
        "photo-books-small-gifts": {
          "content": "Ja, kleine Fotobücher sind tolle Geschenke – perfekt, um Erinnerungen zu teilen, ob zum Geburtstag, Jubiläum oder zu den Feiertagen.",
          "title": "Eignen sich kleine Fotobücher als Geschenk?"
        },
        "photo-books-small-materials": {
          "content": "Mixtiles verwendet hochwertige Materialien: samtiges, holzfreies Papier mit seidenähnlichem Griff, das Reflexionen reduziert und Farben verstärkt, sowie ein Hardcover mit matter Folienbeschichtung.",
          "title": "Welche Materialien und Veredelungen nutzen kleine Fotobücher?"
        },
        "photo-books-small-story": {
          "content": "Wähle Fotos, die zu deinem Thema passen, und ordne sie in einer sinnvollen Reihenfolge an. Nutze unsere Bearbeitungstools und gib dem Cover einen Titel, der deine Sammlung auf den Punkt bringt.",
          "title": "Wie erzählt ein kleines Fotobuch eine stimmige Geschichte?"
        },
        "photo-books-boudoir-what-is": {
          "content": "Ein Boudoir-Fotobuch ist eine persönliche Sammlung intimer, künstlerischer Fotos, die Schönheit und Selbstvertrauen feiern. Mixtiles bindet und druckt auf Premium-Papier – für ein wertvolles Andenken.",
          "title": "Was ist ein Boudoir-Fotobuch und warum eines erstellen?"
        },
        "photo-books-boudoir-select-photos": {
          "content": "Wähle Bilder, die Persönlichkeit und Story widerspiegeln – mit unterschiedlichen Posen und Ausdrücken. Mit Mixtiles kannst du bequem zoomen, zuschneiden und neu anordnen.",
          "title": "Wie wähle ich Fotos für ein Boudoir-Buch aus?"
        },
        "photo-books-boudoir-layout": {
          "content": "Achte auf Balance zwischen Optik und Erzählung. Bei Mixtiles steht pro Seite ein Foto, damit jedes Motiv wirkt. Die Reihenfolge kannst du frei gestalten.",
          "title": "Wie sollte ich die Fotos in einem Boudoir-Buch anordnen?"
        },
        "photo-books-boudoir-size-style": {
          "content": "Es gibt drei Größen: {{v1}}, {{v2}}, {{v3}}. Wähle passend zu deinen Vorlieben und der Fotomenge. Das matte Hardcover verleiht elegante Note – ideal für Boudoir.",
          "title": "Welche Größe und welcher Stil für ein Boudoir-Fotobuch?"
        },
        "photo-books-boudoir-personalize": {
          "content": "Personalisierung ist leicht: Titelfoto wählen und Text für die Vorderseite hinzufügen – so wird dein Boudoir-Buch unverwechselbar.",
          "title": "Wie kann ich mein Boudoir-Fotobuch personalisieren?"
        },
        "photo-books-boudoir-cover-materials": {
          "content": "Mixtiles bietet ein elegantes, mattes Hardcover für Langlebigkeit. Traditionell werden für Boudoir-Bücher auch Materialien wie Leder oder Samt genutzt – für extra Luxus.",
          "title": "Welche Cover-Materialien eignen sich für Boudoir-Bücher?"
        },
        "photo-books-boudoir-color-mix": {
          "content": "Eine Mischung aus Farb- und Schwarzweißfotos sorgt für Tiefe und Kontrast. Schwarzweiß betont Emotionen, Farbe bringt Lebendigkeit. Unsere Premium-Drucke lassen beides strahlen.",
          "title": "Sollte ich Farb- und Schwarzweißbilder mischen?"
        },
        "photo-books-boudoir-order": {
          "content": "Bestelle dein Boudoir-Fotobuch über die Mixtiles Website oder App. Mit der Ein-Klick-Erstellung lädst du Bilder hoch und ordnest sie im Handumdrehen. Support gibt's per E-Mail oder Live-Chat.",
          "title": "Wo kann ich ein Boudoir-Fotobuch bestellen?"
        },
        "photo-books-travel-why-make": {
          "content": "Ein Reise-Fotobuch bewahrt deine Abenteuer und lässt sie wieder aufleben. Mixtiles bietet personalisierte Bücher, die das Wesen deiner Reisen einfangen – greifbarer als ein digitales Album.",
          "title": "Warum ein Reise-Fotobuch erstellen?"
        },
        "photo-books-travel-features": {
          "content": "Füge Karten, Routen, Bildunterschriften und Notizen hinzu, um deine Geschichte zu vertiefen. Mit Mixtiles ordnest du Fotos und Text so, wie es zu deiner Reise passt.",
          "title": "Welche Features kann ich einem Reise-Fotobuch hinzufügen?"
        },
        "photo-books-travel-cropping": {
          "content": "Unsere Plattform macht Zuschneiden und Neuordnen einfach. Das Layout \"eine Seite – ein Foto\" gibt jeder Erinnerung maximale Aufmerksamkeit und sorgt für einen klaren Look.",
          "title": "Wie funktionieren Zuschnitt und Layouts bei Reise-Fotobüchern?"
        },
        "photo-books-travel-details": {
          "content": "Ergänze Bildunterschriften, Daten, Orte oder Auszüge aus deinem Reiseplan – so erzählst du die Geschichte hinter jedem Bild.",
          "title": "Welche Reisedetails kann ich einbauen?"
        },
        "photo-books-travel-structure": {
          "content": "Strukturiere dein Buch mit einem starken Cover, einer Einleitungsseite und ordne Fotos chronologisch oder thematisch (Landschaften, Kultur, Kulinarik). Kurze Texte führen durch die Reise.",
          "title": "Wie strukturiere ich ein Reise-Fotobuch für eine gute Story?"
        },
        "photo-books-travel-quality": {
          "content": "Ja, Mixtiles Reise-Fotobücher sind hochwertig und langlebig: samtiges Papier mit seidenähnlichem Griff, das Reflexionen reduziert und Farben verstärkt, plus mattes Hardcover. Außerdem: umweltfreundliche Materialien.",
          "title": "Sind Reise-Fotobücher hochwertig und langlebig?"
        },
        "photo-books-travel-services": {
          "content": "Mixtiles bietet eine Ein-Klick-Erstellung: Nach dem Hochladen ordnen wir die Fotos zu einem sofort bestellbaren Buch, das du weiter anpassen kannst. Drei Größen stehen zur Auswahl.",
          "title": "Welche Vorlagen oder Services gibt es für Reise-Fotobücher?"
        },
        "photo-books-travel-relive": {
          "content": "Ein Mixtiles Reise-Fotobuch ist mehr als Bilder: Jede Seite weckt Emotionen und macht das Teilen mit Familie und Freunden leicht – in einem schönen, greifbaren Format.",
          "title": "Wie hilft mir ein Reise-Fotobuch, meine Abenteuer neu zu erleben?"
        },
        "photo-books-coffee-table-what-is": {
          "content": "Ein Coffee-Table-Fotobuch ist ein hochwertig gestaltetes Buch, das Gäste zum Durchblättern einlädt. Mixtiles macht daraus eine persönliche Bildgeschichte und einen eleganten Blickfang fürs Zuhause.",
          "title": "Was ist ein Coffee-Table-Fotobuch und warum eines machen?"
        },
        "photo-books-coffee-table-themes": {
          "content": "Beliebte Themen: Familie, Reisen, Hochzeiten oder ein Jahresrückblick. Mit Mixtiles erstellst du dein individuelles Coffee-Table-Buch im Handumdrehen.",
          "title": "Welche Themen eignen sich für ein Coffee-Table-Fotobuch?"
        },
        "photo-books-coffee-table-design": {
          "content": "Das Design ist einfach: Fotos hochladen und anordnen, eine Seite – ein Foto, mit Zoom, Zuschnitt und Neuordnung für eine fließende Geschichte.",
          "title": "Wie gestalte ich ein ansprechendes Coffee-Table-Fotobuch (Layout & Inhalt)?"
        },
        "photo-books-coffee-table-travel-wedding": {
          "content": "Unbedingt! Reise- und Hochzeitsfotos sind visuell stark und emotional. Mit seidig anmutenden Seiten und mattem Hardcover kommen sie perfekt zur Geltung.",
          "title": "Soll ich Reise- oder Hochzeitsfotos in ein Coffee-Table-Buch aufnehmen?"
        },
        "photo-books-coffee-table-gifts": {
          "content": "Ja, Coffee-Table-Bücher sind persönliche, zeitlose Geschenke – ideal für Geburtstage, Jahrestage und weitere Anlässe.",
          "title": "Eignen sich Coffee-Table-Fotobücher als Geschenk?"
        },
        "photo-books-coffee-table-year-review": {
          "content": "Ein Jahresrückblick-Buch sammelt die schönsten Momente des letzten Jahres. Mit Mixtiles präsentierst du bis zu {{max_photos}} Highlights in einem eleganten Band.",
          "title": "Was ist ein Coffee-Table-Fotobuch als Jahresrückblick?"
        },
        "photo-books-coffee-table-guest-house": {
          "content": "Ideal für Gästehäuser oder Wartebereiche: Es schafft eine einladende Atmosphäre und beschäftigt Besucher – z. B. mit lokalen Highlights oder Bildstrecken.",
          "title": "Wie lassen sich Coffee-Table-Bücher in Gästehaus oder Wartezimmer nutzen?"
        },
        "photo-books-coffee-table-suitable": {
          "content": "Ein gutes Coffee-Table-Buch ist ansprechend, robust und bedeutungsvoll. Mixtiles vereint dies mit Premium-Materialien, klarem Design und persönlicher Note.",
          "title": "Was macht ein Fotobuch tischgeeignet?"
        },
        "photo-books-engagement-what-is": {
          "content": "Ein Verlobungs-Fotobuch sammelt die besonderen Momente bis zur Hochzeit. Mixtiles druckt auf samtigem, seidenähnlichem Papier mit mattem Hardcover – ein edles, langlebiges Andenken.",
          "title": "Was ist ein Verlobungs-Fotobuch und warum eines erstellen?"
        },
        "photo-books-engagement-photos-include": {
          "content": "Wähle eine Mischung, die eure Beziehung zeigt: spontane Momente, Verlobungsshooting und besondere Erlebnisse. Schneide zu, zoome und ordne neu – ganz einfach.",
          "title": "Welche Fotos gehören in ein Verlobungs-Fotobuch?"
        },
        "photo-books-engagement-proposal": {
          "content": "Auf jeden Fall! Die Fotos des Antrags gehören hinein – sie setzen den emotionalen Auftakt eurer Geschichte.",
          "title": "Soll ich die Antragsfotos ins Buch aufnehmen?"
        },
        "photo-books-engagement-party": {
          "content": "Fotos von der Verlobungsparty bereichern das Buch mit Freude und Stimmung. Mit Mixtiles kannst du bis zu {{max_photos}} Fotos einbinden.",
          "title": "Und die Verlobungsparty – soll die ins Buch?"
        },
        "photo-books-engagement-vs-wedding": {
          "content": "Verlobungsbücher zeigen den Weg bis zur Hochzeit (Antrag, Feiern, Alltag). Hochzeitsbücher dokumentieren vor allem den Hochzeitstag.",
          "title": "Wie unterscheiden sich Verlobungs- und Hochzeitsfotobücher?"
        },
        "photo-books-engagement-cover-styles": {
          "content": "Wir bieten ein elegantes, mattes Hardcover. Wähle ein Titelfoto und personalisiere den Buchrücken mit Text.",
          "title": "Welche Cover-Stile und Materialien gibt es für Verlobungsbücher?"
        },
        "photo-books-engagement-story": {
          "content": "Erzähle eure Reise vom \"Ja\" bis zur Hochzeit mit einer kuratierten Auswahl in sinnvoller Reihenfolge. Unsere Plattform unterstützt dich dabei.",
          "title": "Wie erzählt ein Verlobungsbuch die Geschichte vom \"Ja\" bis zur Hochzeit?"
        },
        "photo-books-engagement-keepsake": {
          "content": "Ja, es ist ein wunderschönes Andenken und kann sogar als Gästebuch auf der Hochzeit dienen. Mixtiles-Qualität sorgt für lange Freude.",
          "title": "Eignet sich ein Verlobungsbuch als Andenken oder Gästebuch?"
        },
        "photo-books-family-why-create": {
          "content": "Ein Familien-Fotobuch bewahrt Erinnerungen greifbar. Mit Mixtiles stellst du eure schönsten Momente mühelos in einem schönen, personalisierten Buch zusammen.",
          "title": "Warum ein Familien-Fotobuch erstellen?"
        },
        "photo-books-family-formats": {
          "content": "Unsere Bücher sind ideal für Familienfotos und gibt es in {{v1}}, {{v2}} und {{v3}}. Eine Seite – ein Foto sorgt dafür, dass jedes Motiv wirkt.",
          "title": "Welche Fotobuch-Formate eignen sich für Familienfotos?"
        },
        "photo-books-family-organize": {
          "content": "Organisieren ist einfach: Lade Fotos hoch, ordne sie für eure Story, schneide zu und zoome. Mit der Ein-Klick-Erstellung startest du im Nu.",
          "title": "Wie organisiere ich ein Familien-Fotobuch?"
        },
        "photo-books-family-memories": {
          "content": "Mische Alltag und besondere Anlässe: Urlaube, Feiertage, Geburtstage und spontane Schnappschüsse, die eure Familie zeigen.",
          "title": "Welche Familienerinnerungen sollte ich aufnehmen?"
        },
        "photo-books-family-pages": {
          "content": "Unsere Bücher zeigen 24 bis {{max_photos}} Fotos – jeweils auf einer eigenen Seite. So wird es entweder ein kompaktes Jahrbuch oder eine umfangreiche Sammlung.",
          "title": "Wie viele Seiten kann ein Familien-Fotobuch haben?"
        },
        "photo-books-family-cover-size": {
          "content": "Mixtiles Bücher haben ein mattes Hardcover und sind in drei Größen erhältlich: {{v1}}, {{v2}} oder {{v3}}.",
          "title": "Welche Cover- und Größenoptionen gibt es für Familien-Fotobücher?"
        },
        "photo-books-family-durable": {
          "content": "Samtiges Papier und ein matter Filmeinband erhöhen die Haltbarkeit. So bleibt dein Familienbuch jahrelang schön. Außerdem: umweltfreundlich und recycelbar.",
          "title": "Wie mache ich ein Familien-Fotobuch besonders langlebig?"
        },
        "photo-books-family-story": {
          "content": "Erzähle eure Familiengeschichte mit Bildunterschriften oder kurzen Anekdoten. Personalisiere das Cover mit einem besonderen Foto und passendem Text.",
          "title": "Wie integriere ich unsere Familiengeschichte ins Buch?"
        },
        "photo-books-yearly-what-is": {
          "content": "Ein Jahresfotoalbum ist eine wunderbare Möglichkeit, die Erinnerungen des Jahres zusammenzufassen und die Essenz Ihrer Erfahrungen und Meilensteine festzuhalten. Bei Mixtiles bieten wir Ihnen eine einfache Möglichkeit, diese besonderen Momente in einem wunderschön gebundenen Buch zu sammeln, damit Sie Ihr Jahr Revue passieren lassen und mit Ihren Liebsten teilen können.",
          "title": "Wofür wird ein Jahresfotoalbum verwendet?"
        },
        "photo-books-yearly-gather-photos": {
          "content": "Um ein umfassendes Jahresfotoalbum zu erstellen, beginnen Sie damit, Ihre Fotos nach Monaten oder wichtigen Ereignissen zu ordnen. So können Sie leicht die Bilder auswählen, die jede Phase Ihres Jahres am besten repräsentieren. Unsere Plattform ermöglicht es Ihnen, diese Fotos mühelos hochzuladen und zu arrangieren, damit Ihr Album eine stimmige Geschichte erzählt.",
          "title": "Wie sammle ich Fotos für ein Jahresalbum?"
        },
        "photo-books-yearly-what-include": {
          "content": "Fügen Sie Ihre schönsten Erlebnisse und Begegnungen des vergangenen Jahres hinzu. Ob Familientreffen, Urlaube oder persönliche Erfolge – unsere Fotobücher geben jeder Erinnerung den Platz, den sie verdient. Mit den einfachen Bearbeitungstools von Mixtiles können Sie Fotos zoomen, zuschneiden und neu anordnen, damit sie perfekt zu Ihrer Geschichte passen.",
          "title": "Was sollte ich in ein Jahresfotoalbum aufnehmen?"
        },
        "photo-books-yearly-themes-layouts": {
          "content": "Eine chronologische Zeitleiste ist ein sehr effektives Thema für ein Jahresfotoalbum. Sie zeigt den Verlauf Ihres Jahres und hebt die wichtigsten Momente in Reihenfolge hervor. Unsere Fotobücher haben ein Layout mit einem Foto pro Seite, das Klarheit und Fokus auf jede Erinnerung gewährleistet.",
          "title": "Welche Themen oder Layouts eignen sich für ein Jahresalbum?"
        },
        "photo-books-yearly-formats": {
          "content": "Wir bieten drei praktische Größen für unsere Fotobücher an: {{v1}}, {{v2}} und {{v3}}. Jede Größe ist auf unterschiedliche Vorlieben zugeschnitten – von dezent bis groß und auffällig. Bei Mixtiles stellen wir sicher, dass Ihr Jahresfotoalbum aus hochwertigen Materialien gefertigt wird, darunter ein mattes Hardcover und seidig-weiche Seiten.",
          "title": "Welche Formate gibt es für Jahresfotobücher?"
        },
        "photo-books-yearly-personalize-cover": {
          "content": "Die Personalisierung des Covers ist mit Mixtiles ganz einfach. Wählen Sie ein besonderes Foto für das Titelblatt und fügen Sie einen individuellen Folientitel hinzu, der Ihre Geschichte zusammenfasst. Diese persönliche Note macht Ihr Jahresalbum einzigartig und individuell.",
          "title": "Wie kann ich das Cover eines Jahresalbums personalisieren?"
        },
        "photo-books-yearly-why-make": {
          "content": "Ein Jahresfotoalbum verwandelt Ihre Highlights in eine Erinnerungszeitkapsel. Es ist eine greifbare Möglichkeit, die wichtigsten Momente zu bewahren und jederzeit wiederzuerleben. Unsere Bücher sind langlebig und werden zu einem beständigen Erinnerungsstück.",
          "title": "Warum sollte ich ein Jahresfotoalbum machen?"
        },
        "photo-books-yearly-how-often": {
          "content": "Wir empfehlen, jedes Jahr ein Jahresfotoalbum zu erstellen, um die Highlights des Jahres festzuhalten. Diese Tradition ermöglicht es Ihnen, eine Sammlung von Erinnerungen aufzubauen, auf die Sie später mit Freude zurückblicken können. Mit Mixtiles ist der Prozess einfach und macht Spaß – jedes Buch wird so besonders wie die Erinnerungen darin.",
          "title": "Wie oft sollte ich ein Jahresfotoalbum machen?"
        },
        "photo-books-valentines-great-gift": {
          "content": "Ein Fotobuch ist ein perfektes Valentinstagsgeschenk, weil es Ihre Liebesgeschichte greifbar macht. Bei Mixtiles bieten wir wunderschön gebundene Fotobücher, mit denen Sie durch wertvolle Erinnerungen blättern können – ein Geschenk von Herzen. Unsere hochwertigen Bücher auf seidig-weichem Papier lassen Ihre Fotos mit lebendigen Farben erstrahlen und schaffen ein bleibendes Andenken an Ihre Liebe.",
          "title": "Warum ist ein Fotobuch ein tolles Valentinstagsgeschenk?"
        },
        "photo-books-valentines-unique-ideas": {
          "content": "Eine originelle Idee ist ein Fotobuch mit dem Thema \"Gründe, warum ich dich liebe\". Sammeln Sie Fotos von besonderen Momenten und ergänzen Sie sie mit Bildunterschriften oder Liebesbotschaften, die ausdrücken, warum Sie Ihren Partner schätzen. Diese persönliche Note verwandelt eine einfache Sammlung in eine bedeutungsvolle Geschichte.",
          "title": "Welche originellen Ideen kann ich für ein Valentinsbuch verwenden?"
        },
        "photo-books-valentines-style": {
          "content": "Für einen zeitlosen Look gestalten Sie Ihr Valentinsbuch komplett in Schwarz-Weiß. Dieser klassische Stil verleiht Eleganz und hebt die Emotionen in jedem Bild hervor. Mit Mixtiles können Sie Ihre Fotos ganz einfach bearbeiten, um diesen Effekt zu erzielen – für ein Buch, das stilvoll und persönlich ist.",
          "title": "Wie kann ich mein Valentinsbuch gestalten?"
        },
        "photo-books-valentines-wedding-photos": {
          "content": "Natürlich! Hochzeitsfotos in ein Valentinsbuch aufzunehmen, ist eine wunderschöne Möglichkeit, einen der romantischsten Momente Ihres Lebens wiederzuerleben. Unsere Bücher zeigen ein Foto pro Seite, sodass jede Erinnerung den Raum erhält, den sie verdient. Ideal, um die Highlights Ihrer Hochzeit zusammen mit anderen wertvollen Erinnerungen zu präsentieren.",
          "title": "Kann ich Hochzeitsfotos in ein Valentinsbuch aufnehmen?"
        },
        "photo-books-valentines-focus": {
          "content": "Konzentrieren Sie sich auf romantische Momente und Erinnerungen, die Ihre Beziehung definieren. Ob erstes Date, unvergesslicher Urlaub oder spontane Alltagsmomente – diese Bilder erzählen Ihre Liebesgeschichte. Mit unseren Bearbeitungstools können Sie die Fotos organisieren und anpassen, damit Ihr Valentinsbuch Ihre gemeinsame Reise widerspiegelt.",
          "title": "Worauf sollte ich mich in einem Valentinsbuch konzentrieren?"
        },
        "photo-books-valentines-fun-personal": {
          "content": "Kombinieren Sie Schnappschüsse und gestellte Fotos, um ein Buch zu schaffen, das sowohl unterhaltsam als auch persönlich ist. Spontane Aufnahmen fangen echte Emotionen ein, während gestellte Fotos besondere Anlässe hervorheben. Mit dem Ein-Klick-Erstellungsprozess von Mixtiles können Sie Ihre Fotos einfach organisieren und persönliche Details hinzufügen – für ein einzigartiges Buch.",
          "title": "Wie mache ich das Buch lustig und persönlich?"
        },
        "photo-books-valentines-suitable-couples": {
          "content": "Ja, ein Valentinsbuch eignet sich für jedes Paar – egal ob frisch verheiratet oder seit Jahren zusammen. Es ist ein vielseitiges Geschenk, das Ihre gemeinsame Reise feiert und sowohl neue als auch alte Erinnerungen festhält. Unsere eleganten und langlebigen Bücher passen zu jeder Beziehungsphase.",
          "title": "Ist ein Valentinsbuch für jedes Paar geeignet?"
        },
        "photo-books-valentines-gather-content": {
          "content": "Sammeln Sie Liebesbotschaften, Lieblingsfotos und bedeutungsvolle Zitate, die Ihre Beziehung widerspiegeln. Legen Sie auf Ihrem Gerät ein Album an, um alles zu speichern und bereit zu haben, wenn Sie Ihr Fotobuch erstellen. Wir empfehlen, mindestens 24 Fotos hochzuladen, um ein vollständiges und herzvolles Valentinsbuch zu gestalten.",
          "title": "Wie sammle ich Inhalte für ein Valentinsalbum?"
        },
        "shipping-location": {
          "content": "Ja, wir liefern in fast alle Länder! ",
          "title": "Versendet ihr weltweit? "
        },
        "shipping-time": {
          "content": "In der Regel dauert der Versand ca. eine Woche. In manchen Ländern bieten wir auch Expressversand an. Den Trackinglink bekommst Du nach Bestellaufgabe zugeschickt.",
          "title": "Wie lange dauert der Versand?"
        },
        "title": "Häufig gestellte Fragen",
        "walls": {
          "content": "Nein, Mixtiles hinterlassen keine Spuren.",
          "title": "Werden sie meine Wand auch wirklich nicht kaputt machen?"
        },
        "photo-books-graduation-why-create": {
          "content": "Ein Abschluss-Fotobuch zu erstellen ist eine wunderbare Möglichkeit, Meilensteinerinnerungen aus einem wichtigen Lebenskapitel zu bewahren. Bei Mixtiles bieten wir wunderschön gebundene Fotobücher an, mit denen du diese besonderen Momente kuratieren und immer wieder erleben kannst. Unsere Fotobücher sind persönliche Erinnerungsstücke, die die Freude und Erfolge des Abschluss­tages festhalten – ein greifbares Andenken an deine Leistungen.",
          "title": "Warum sollte ich ein Abschluss‑Fotobuch erstellen?"
        },
        "photo-books-graduation-what-photos": {
          "content": "Ein ausgewogenes Abschluss‑Fotobuch sollte verschiedene Fotos enthalten: die Aufregung des ersten Tages, den Stolz der Zeremonie, spontane Momente mit Freund:innen und prägende Ereignisse im gesamten Schuljahr. Zusammen erzählen diese Bilder deine Geschichte und zeigen Wachstum und Erfolge.",
          "title": "Welche Fotos soll ich in ein Abschlussalbum aufnehmen?"
        },
        "photo-books-graduation-organize": {
          "content": "Du kannst deine Abschlussfotos chronologisch oder thematisch sortieren. Bei Mixtiles machen wir es dir leicht, deine Fotos genau so anzuordnen, wie du möchtest. Ob du die Reise von Anfang bis Ende zeigst oder nach Events oder Freundschaften gruppierst – mit unseren einfachen Bearbeitungstools passt du dein Buch an deine einzigartige Geschichte an.",
          "title": "Wie sollte ich die Fotos organisieren?"
        },
        "photo-books-graduation-how-many-photos": {
          "content": "Für ein Mixtiles Abschluss‑Fotobuch brauchst du mindestens 24 Fotos und kannst bis zu {{max_photos}} einfügen. Sammle die Bilder von deinen Geräten, aus sozialen Netzwerken oder von Freund:innen, die besondere Momente festgehalten haben. So entsteht ein umfassendes und lebendiges Bild deiner Abschlusszeit.",
          "title": "Wie viele Fotos brauche ich und wo finde ich sie?"
        },
        "photo-books-graduation-design-theme": {
          "content": "Das Designthema für dein Abschluss‑Fotobuch hängt von deinem Stil und der Geschichte ab, die du erzählen möchtest. Unsere Bücher haben einen eleganten, matten Hardcover‑Einband und werden auf samtigem Papier mit Seiden‑Haptik gedruckt – für großartige Optik und Haptik. Ob klassisch‑elegant oder modern und farbenfroh: Wir lassen deine Fotos mit satten Farben und Premium‑Qualität erstrahlen.",
          "title": "Welches Designthema soll ich für mein Abschlussbuch wählen?"
        },
        "photo-books-graduation-quotes-messages": {
          "content": "Ja, du kannst dein Abschluss‑Fotobuch personalisieren und Zitate oder Nachrichten ergänzen, die zu deinem Weg passen. Zwar bieten wir keine eigene Funktion zum Erstellen von QR‑Codes an, aber du kannst extern einen erzeugen und als Bild hochladen. So fügst du interaktive Elemente hinzu und erhöhst den persönlichen Wert deines Buchs.",
          "title": "Kann ich Zitate, Nachrichten oder QR‑Codes einfügen?"
        },
        "photo-books-graduation-sort-upload": {
          "content": "Deine Abschlussfotos mit Mixtiles zu sortieren und hochzuladen ist kinderleicht. Unsere Ein‑Tipp‑Erstellung ordnet deine Fotos zu Seiten – das Buch ist sofort bestellbereit. Danach kannst du weiter personalisieren und anordnen, damit jede Seite deinen persönlichen Touch hat.",
          "title": "Wie sortiere und lade ich meine Abschlussfotos hoch?"
        },
        "photo-books-graduation-templates-layouts": {
          "content": "Unsere Fotobücher haben ein klares Layout mit einem Foto pro Seite, damit jede Erinnerung im Mittelpunkt steht. Dieses einfache, wirkungsvolle Design lässt jede Aufnahme für sich wirken – ideal, um die Essenz deiner Abschlussreise festzuhalten. Mit unseren Tools kannst du zuschneiden und neu anordnen, damit alles zu deiner Geschichte passt.",
          "title": "Welche Vorlagen oder Layouts passen für ein Abschlussbuch?"
        },
        "photo-books-birthday-important-moments": {
          "content": "Die Essenz einer Geburtstagsfeier in einem Fotobuch einzufangen heißt, sich auf Schlüsselmomente zu konzentrieren – Tortenanschnitt, Geschenke öffnen und das Miteinander der Gäste. Diese Szenen zeigen die Freude und Aufregung des Tages und sind wichtig für ein vollständiges Buch. Mit Mixtiles kannst du diese Erinnerungen bei jedem Umblättern neu erleben.",
          "title": "Welche Momente sind für ein Geburtstags‑Fotobuch wichtig?"
        },
        "photo-books-birthday-photograph-party": {
          "content": "Für ein beeindruckendes Geburtstags‑Fotobuch mischst du Weitwinkel‑ und Nahaufnahmen. Nimm den ganzen Raum auf, um die Stimmung zu setzen, und zoome auf Details wie Deko und Gesichtsausdrücke. Unsere Bücher werden auf samtigem Papier mit Seiden‑Haptik gedruckt – so strahlt jedes Foto, vom großen Ganzen bis zum kleinsten Detail, in lebendigen Farben.",
          "title": "Wie fotografiere ich eine Party für ein tolles Fotobuch?"
        },
        "photo-books-birthday-candid-vs-posed": {
          "content": "Gestellte Fotos haben ihren Platz, doch spontane Aufnahmen fangen oft die echte Freude und Spontaneität ein. Halte Lachen, Überraschungen und Interaktionen fest – für ein authentisches Bild der Feier. Mit den einfachen Bearbeitungsfunktionen von Mixtiles ordnest du diese Schnappschüsse zu einer Geschichte, die den Spirit der Party widerspiegelt.",
          "title": "Soll ich eher spontane oder gestellte Fotos machen?"
        },
        "photo-books-birthday-details-include": {
          "content": "Details wie Deko, Geburtstagskuchen und die Lächeln der Gäste geben deinem Buch Tiefe. Sie zeichnen ein vollständiges Bild des Events und machen dein Fotobuch zu einem lebendigen Andenken. Mit unserem anpassbaren Layout – ein Foto pro Seite – kannst du jedes dieser Details in Szene setzen.",
          "title": "Welche Details sollte ich aufnehmen?"
        },
        "photo-books-birthday-tell-story": {
          "content": "Damit deine Fotos eine Geschichte erzählen, ordne sie chronologisch – von der Ankunft der Gäste bis zu den letzten Verabschiedungen. So entsteht ganz natürlich ein roter Faden. Bei Mixtiles sorgt unsere Ein‑Tipp‑Erstellung für einen stimmigen Ablauf, den du bei Bedarf weiter anpassen kannst.",
          "title": "Wie stelle ich sicher, dass die Fotos eine Geschichte erzählen?"
        },
        "photo-books-birthday-angle-focus": {
          "content": "Ein Thema oder Fokus – z. B. eine Farbwelt oder ein Party‑Motiv – gibt deinem Buch eine besondere Note. Das hilft bei Auswahl und Reihenfolge der Fotos und sorgt für einen stimmigen Look. Der schlanke, matte Hardcover‑Einband unserer Bücher passt zu jedem Thema und verleiht deinem Andenken Eleganz.",
          "title": "Ist ein bestimmtes Thema oder Fokus hilfreich?"
        },
        "photo-books-birthday-subjects-interest": {
          "content": "Inhalte wie Partyspiele, besondere Outfits oder einzigartige Begegnungen bringen Abwechslung auf jede Seite. Sie sorgen für Spannung beim Umblättern. Mit den hochwertigen Mixtiles‑Fotobüchern bekommt jedes Bild die Bühne, die es verdient – für wunderschön bewahrte Erinnerungen.",
          "title": "Welche Motive schaffen auf jeder Seite Interesse?"
        },
        "photo-books-birthday-how-many-photos": {
          "content": "Für ein ausgewogenes Geburtstagsbuch empfehlen wir 50–100 Fotos. So deckst du das Event ab, ohne zu überfrachten. Mixtiles‑Bücher fassen bis zu 150 Fotos – genug Flexibilität für alle Lieblingsmomente bei klarer, ordentlicher Gestaltung.",
          "title": "Wie viele Fotos soll ich von der Party aufnehmen?"
        },
        "photo-books-retirement-how-create": {
          "content": "Ein Ruhestands‑Fotobuch mit Mixtiles zu erstellen ist einfach und macht Spaß. Lade zunächst mindestens 24 Fotos über unsere Website oder App hoch – bis zu {{max_photos}} kostbare Erinnerungen. Unsere intuitive Plattform ordnet die Bilder automatisch; du kannst das Layout aber personalisieren, um eine einzigartige Geschichte zu erzählen. Eine Seite, ein Foto – so glänzt jeder Moment. Mit unserem Premium‑Papier in Seiden‑Haptik und dem eleganten, matten Hardcover wird es ein wunderschönes Geschenk für Kolleg:innen oder Lieblingsmenschen.",
          "title": "Wie erstelle ich ein Ruhestands‑Fotobuch für eine:n Kolleg:in oder einen lieben Menschen?"
        },
        "photo-books-retirement-when-start-planning": {
          "content": "Wir empfehlen, mindestens einen Monat vorher zu starten. So bleibt genug Zeit, bedeutungsvolle Fotos und Beiträge von Kolleg:innen zu sammeln – für ein umfassendes, herzliches Buch. Früh zu planen heißt auch: unsere Bearbeitungsfunktionen optimal nutzen und alles perfekt anordnen. Du kannst deine Auswahl zwischenspeichern und das Meisterwerk fertigstellen, wenn es passt.",
          "title": "Wann sollte ich mit der Planung beginnen?"
        },
        "photo-books-retirement-types-photos": {
          "content": "Ein Ruhestandsbuch sollte die Karriere und Persönlichkeit der Person zeigen. Kombiniere berufliche Highlights – wichtige Projekte, Auszeichnungen, Beförderungen – mit spontanen Büro‑Momenten, die Alltag und Freundschaften widerspiegeln. In unseren Büchern kannst du zuschneiden und anordnen, damit jedes Foto in deine Erzählung passt.",
          "title": "Welche Fotoarten sollte ich aufnehmen?"
        },
        "photo-books-retirement-coworkers-contribute": {
          "content": "Auf jeden Fall! Kolleg:innen um Fotos und persönliche Nachrichten zu bitten, gibt dem Buch Tiefe und Wärme. So fließen unterschiedliche Perspektiven und Erinnerungen ein. Mixtiles unterstützt Zusammenarbeit – Beiträge aus mehreren Quellen lassen sich leicht hochladen und organisieren.",
          "title": "Sollen Kolleg:innen Beiträge beisteuern?"
        },
        "photo-books-retirement-humor-personal-touches": {
          "content": "Humor und persönliche Akzente machen dein Buch besonders. Füge lustige Ratschläge, Büro‑Insider oder prägende Zitate aus der Laufbahn hinzu. Auch Fotos von Büro‑Andenken oder besonderen Events sind schön. Mit unseren Optionen integrierst du Text und Bilder ganz einfach.",
          "title": "Wie kann ich Humor oder persönliche Akzente hinzufügen?"
        },
        "photo-books-retirement-layout-ideas": {
          "content": "Eine Timeline der Karriere‑Meilensteine ist eine starke Struktur. Beginne mit den frühen Jahren und führe bis zum Ruhestand – Highlights und Übergänge im Fokus. Mit unserem Layout (ein Foto pro Seite) bekommt jedes Etappenziel die Aufmerksamkeit, die es verdient; umordnen geht jederzeit leicht.",
          "title": "Welche Layout‑Ideen machen es besonders?"
        },
        "photo-books-retirement-photo-quality": {
          "content": "Bildqualität ist entscheidend. Wir empfehlen eine Auflösung zwischen 600 × 600 und 7000 × 7000 Pixeln für klare, lebendige Drucke. Unsere Plattform meldet sich, wenn etwas darunter liegt – so wählst du die beste Alternative.",
          "title": "Wie wichtig ist die Fotoqualität für ein Ruhestandsalbum?"
        },
        "photo-books-retirement-meaningful-gifts": {
          "content": "Ruhestands‑Fotobücher sind bedeutungsvolle Geschenke: Sie fassen den beruflichen Weg und menschliche Verbindungen zusammen. Ein greifbarer Rahmen für Erfolge und liebgewonnene Erinnerungen. Bei Mixtiles sorgen wir für ein hochwertiges, persönliches Andenken, das viele Jahre Freude macht.",
          "title": "Warum sind Ruhestands‑Fotobücher so bedeutungsvoll?"
        },
        "photo-books-fathers-day-great-gift": {
          "content": "Ein Fotobuch ist ein großartiges Geschenk zum Vatertag, denn es hält wertvolle Erinnerungen und persönliche Momente fest, die die individuelle Geschichte deines Vaters feiern. Unsere schön gebundenen Bücher vereinen Familienmomente, Urlaube und Meilensteine zu einem Andenken, das Papa für immer schätzen wird – langlebig und elegant dank hochwertiger Materialien.",
          "title": "Warum ist ein Fotobuch ein tolles Vatertagsgeschenk?"
        },
        "photo-books-fathers-day-memories-include": {
          "content": "Nimm eine Mischung aus Erinnerungen auf, die verschiedene Seiten von Papas Leben zeigen: Babyfotos, Familienreisen, große Ereignisse. Mit einer Foto‑pro‑Seite kommt jede Erinnerung zur Geltung. Mit unseren Tools schneidest du zu und ordnest so, dass die Geschichte perfekt passt.",
          "title": "Welche Erinnerungen sollte ich aufnehmen?"
        },
        "photo-books-fathers-day-make-special": {
          "content": "Für das gewisse Extra nutze ein \"Früher & Heute\"‑Thema. Starte mit Kindheitsfotos, geh über wichtige Lebensereignisse bis zu aktuellen Treffen oder Erfolgen. Personalisiere das Cover mit einem bedeutungsvollen Bild und einem kurzen Text, der eure Geschichte zusammenfasst. Mit Mixtiles wird daraus mühelos ein persönliches Andenken.",
          "title": "Wie mache ich das Fotobuch für Papa besonders?"
        },
        "photo-books-fathers-day-involve-children": {
          "content": "Kinder einzubeziehen, macht es besonders herzlich. Bitte sie um Zeichnungen oder kurze Notizen, die du scannen und hinzufügen kannst. So wird das Geschenk zu einem Familienprojekt. Mixtiles gibt dir die kreative Freiheit für ein einzigartiges Vatertags‑Fotobuch.",
          "title": "Soll ich die Kinder einbeziehen?"
        },
        "photo-books-fathers-day-format-recommended": {
          "content": "Unsere Bücher haben einen eleganten, matten Hardcover‑Einband – robust und edel zugleich. Anders als klassische Lederalben oder Softcover drucken wir auf samtigem Papier mit Seiden‑Haptik: weniger Reflexionen, kräftige Farben. Premium‑Gefühl und schön bewahrte Erinnerungen.",
          "title": "Welches Format wird empfohlen?"
        },
        "photo-books-fathers-day-who-book-for": {
          "content": "Ein Vatertags‑Fotobuch passt für frischgebackene Väter, Großväter und jede Vaterfigur dazwischen. Ob erster Vatertag oder viele Jahre Vatersein – unsere Bücher lassen sich auf jede Geschichte zuschneiden. Mit Größen von {{v1}} bis {{v3}} findest du das perfekte Format.",
          "title": "Für wen ist dieses Buch gedacht?"
        },
        "photo-books-fathers-day-how-many-photos": {
          "content": "Unsere Bücher zeigen 24 bis {{max_photos}} Fotos – jeweils eines pro Seite. So kannst du je nach Wunsch eine umfangreiche oder kompakte Sammlung gestalten.",
          "title": "Wie viele Fotos oder Seiten soll ich einplanen?"
        },
        "photo-books-fathers-day-nostalgic-photos": {
          "content": "Auf jeden Fall! Nostalgische Familienfotos sind ideal. Lade Bilder mit mindestens 600 × 600 Pixeln hoch, damit alles scharf wird. Mit unseren Premium‑Drucken wird Familiengeschichte bei jedem Umblättern lebendig.",
          "title": "Kann ich alte Familienfotos verwenden?"
        },
        "photo-books-pet-dog-create-personalized": {
          "content": "Ein persönliches Hunde‑Album mit Mixtiles zu erstellen ist ein Kinderspiel! Lade deine Lieblingsfotos über Website oder App hoch – unsere Plattform ordnet sie automatisch zu einem tollen Fotobuch. Danach kannst du weiter anpassen: umsortieren, zuschneiden, persönliche Akzente setzen. Gedruckt auf samtigem Papier mit robuster, matter Hardcover‑Umschlag – für Erinnerungen, die lange bleiben.",
          "title": "Wie erstelle ich ein persönliches Hunde‑Fotoalbum?"
        },
        "photo-books-pet-dog-photos-include": {
          "content": "Zeige verschiedene Momente, die die Persönlichkeit deines Hundes und eure gemeinsamen Erlebnisse widerspiegeln: Alltags­kapriolen, Spielspaß und ruhige Augenblicke. Du kannst zwischen 24 und {{max_photos}} Fotos hochladen – genug Raum für eure Geschichte.",
          "title": "Welche Fotos sollte ich ins Hundealbum aufnehmen?"
        },
        "photo-books-pet-dog-puppy-family-photos": {
          "content": "Klar! Welpenfotos zusammen mit Familienbildern ergeben eine herzerwärmende Erzählung. Misch verschiedene Lebensphasen deines Tiers mit Familien‑Meilensteinen – so entsteht ein vollständiges Andenken, das deinen Fellfreund als Teil der Familie feiert.",
          "title": "Kann ich Welpenfotos und Familienbilder kombinieren?"
        },
        "photo-books-pet-dog-choose-best-photos": {
          "content": "Wähle hochwertige Bilder, die Emotionen wecken und eine Geschichte erzählen. Achte auf unsere empfohlene Auflösung von 600 × 600 bis 7000 × 7000 Pixeln für beste Druckqualität. Mit den Bearbeitungstools kannst du zuschneiden und optimieren – so wird jede Seite bildschön.",
          "title": "Wie wähle ich die besten Hundebilder aus?"
        },
        "photo-books-pet-dog-why-make-album": {
          "content": "Ein Album für deinen Hund ist eine schöne Art, eure besondere Bindung zu feiern und zu bewahren. Als persönliches Andenken lässt es dich Lieblingsmomente und Meilensteine immer wieder erleben. Auf dem Couchtisch oder zum Teilen mit Liebsten – ein bedeutungsvolles Tribute an deinen Vierbeiner.",
          "title": "Warum ein Fotoalbum für meinen Hund machen?"
        },
        "photo-books-pet-dog-templates-design-ideas": {
          "content": "Mixtiles bietet keine spezifischen Vorlagen, aber unsere Ein‑Tipp‑Erstellung macht das Design super einfach. Nach dem Upload werden die Fotos automatisch in ein klares Layout gebracht, das du weiter anpassen kannst. So kann deine Kreativität glänzen – passend zu deinem Stil und der Geschichte deines Hundes.",
          "title": "Gibt es Vorlagen oder Design‑Ideen für ein Hunde‑Fotobuch?"
        },
        "photo-books-pet-dog-include-milestones": {
          "content": "Meilensteine wie der \"erste Spaziergang\" oder \"erstes Weihnachten\" geben deinem Album Tiefe und Bedeutung. Sie zeigen das Wachstum deines Tiers und eure gemeinsamen Erlebnisse. Mit einer Foto‑pro‑Seite hat jeder Meilenstein seinen großen Auftritt.",
          "title": "Soll ich Meilensteine wie \"erster Spaziergang\" oder \"erstes Weihnachten\" aufnehmen?"
        },
        "photo-books-pet-dog-gift-idea": {
          "content": "Ja! Ein personalisiertes Hunde‑Album ist ein tolles, individuelles Geschenk für jeden Tierfan. Beim Bestellen kannst du mehrere identische Exemplare wählen – so teilst du die schönen Erinnerungen ganz einfach.",
          "title": "Eignet sich das Hundealbum als Geschenk?"
        },
        "photo-books-anniversary-great-gift": {
          "content": "Ein Jubiläums‑Fotobuch ist ein zeitloses Geschenk, das eure gemeinsame Reise wunderschön einfängt. Bei Mixtiles erstellen wir persönliche Andenken, mit denen ihr eure Lieblingsmomente in einem eleganten, hochwertig gebundenen Buch sammelt. Jedes Umblättern lässt Erinnerungen aufleben – perfekt, um eure Liebesgeschichte zu feiern.",
          "title": "Warum ist ein Fotobuch ein tolles Jubiläumsgeschenk?"
        },
        "photo-books-anniversary-memories-include": {
          "content": "Kombiniert wichtige Meilensteine und Alltagsmomente für eine runde Erzählung. Denkt an das erste gemeinsame Foto, besondere Reisen und unvergessliche Feiern. Mit unseren einfachen Tools ordnet ihr alles nahtlos – so erzählt euer Album eure ganz eigene Geschichte.",
          "title": "Welche Erinnerungen gehören in ein Jubiläums‑Fotobuch?"
        },
        "photo-books-anniversary-how-many-photos": {
          "content": "Ihr könnt zwischen 24 und {{max_photos}} Fotos aufnehmen – die ideale Zahl hängt von eurer Geschichte ab. Unser Layout mit einer Foto‑pro‑Seite gibt jeder Erinnerung die Bühne und sorgt für eine saubere, elegante Präsentation.",
          "title": "Wie viele Fotos sind ideal?"
        },
        "photo-books-anniversary-everyday-candid-moments": {
          "content": "Unbedingt! Spontane Alltagsmomente bringen Authentizität. Oft zeigen sie das wahre Wesen eurer Beziehung. Bei Mixtiles finden wir: Jeder Moment ist feierwürdig.",
          "title": "Sollten auch Alltags‑ oder Spontanmomente rein?"
        },
        "photo-books-anniversary-personal-unique": {
          "content": "Macht euer Buch persönlich: Wählt ein besonderes Cover‑Foto und passt den Text an, der eure Geschichte zusammenfasst. Mit unserer Plattform könnt ihr zuschneiden und anordnen, bis alles passt. Unsere Seiten mit Seiden‑Haptik sehen nicht nur toll aus, sie fühlen sich auch besonders an.",
          "title": "Wie machen wir das Jubiläumsbuch persönlich und einzigartig?"
        },
        "photo-books-anniversary-any-year-celebration": {
          "content": "Ja – Jubiläumsbücher passen zu jedem Jahr. Ob erstes oder fünfzigstes Jubiläum: Unsere robusten, matten Hardcover heben eure Erinnerungen hervor. Eine bedeutungsvolle Art, euren Weg Jahr für Jahr zu würdigen.",
          "title": "Eignet es sich für jedes Jubiläumsjahr?"
        },
        "photo-books-anniversary-photo-quality": {
          "content": "Für die besten, klaren Drucke nutzt Fotos zwischen 600 × 600 und 7000 × 7000 Pixeln. Unsere Plattform meldet sich, wenn etwas nicht passt – so könnt ihr Alternativen wählen und ein perfektes Buch gestalten.",
          "title": "Welche Fotoqualität sollten wir verwenden?"
        },
        "photo-books-anniversary-tell-love-story": {
          "content": "Startet, indem ihr die Fotos chronologisch oder thematisch ordnet. Unsere Ein‑Tipp‑Erstellung hilft beim schnellen Hochladen und Anordnen. Mit Mixtiles habt ihr kreative Freiheit für ein Album, das eure Liebesgeschichte wunderschön erzählt – ein Andenken für viele Jahre.",
          "title": "Wie erzählen wir unsere Liebesgeschichte im Buch?"
        },
        "photo-books-mothers-day-perfect-gift": {
          "content": "Ein Fotobuch ist ein perfektes Muttertagsgeschenk: Es bewahrt geliebte Erinnerungen in greifbarer Form, die man immer wieder ansehen kann. Bei Mixtiles bieten wir schön gebundene Bücher, mit denen du ein persönliches Andenken gestaltest. Anders als ein klassisches Album haben unsere Bücher einen schlanken, matten Hardcover‑Einband und Seiten aus samtigem Papier – ein hochwertiges Geschenk, das Mama lieben wird.",
          "title": "Warum ist ein Fotobuch ein perfektes Muttertagsgeschenk?"
        },
        "photo-books-mothers-day-memories-include": {
          "content": "Nimm eine Mischung aus Familienmomenten, Urlaubs‑Highlights und Meilensteinen auf. Diese Erinnerungen zeigen euren Weg und eure Bindung. Mit unseren Bearbeitungstools ordnest du alles genau so, wie du möchtest, damit jeder Moment im Rampenlicht steht.",
          "title": "Welche Erinnerungen gehören in ein Muttertags‑Fotobuch?"
        },
        "photo-books-mothers-day-personalize-book": {
          "content": "Dein Buch zu personalisieren ist mit Mixtiles ganz einfach. Füge Bildunterschriften und Notizen hinzu – für Kontext und herzliche Botschaften, die den emotionalen Effekt verstärken. Wähle ein besonderes Cover‑Foto und passe den Text an, um eure Geschichte zu umreißen – so wird das Buch wirklich einzigartig.",
          "title": "Wie kann ich das Buch für Mama personalisieren?"
        },
        "photo-books-mothers-day-creative-themes": {
          "content": "Kreative Themen sind z. B. \"Ein Jahr im Rückblick\", \"Generationen der Liebe\" oder \"Mamas Lieblingsmomente\". Jedes Buch nutzt ein Layout mit einem Foto pro Seite – ideal, um eine klare Geschichte zu erzählen. Unsere benutzerfreundliche Plattform ordnet deine Fotos sogar automatisch – ein beeindruckendes Buch in wenigen Tipps.",
          "title": "Welche kreativen Themen funktionieren gut?"
        },
        "photo-books-mothers-day-shared-activities": {
          "content": "Auf jeden Fall! Fotos gemeinsamer Aktivitäten und besonderer Momente sind essenziell – sie zeigen die Essenz eurer Beziehung und die Erlebnisse, die euch verbinden. Unsere Bücher präsentieren diese Erinnerungen mit kräftigen Farben und hochwertigem Druck.",
          "title": "Soll ich gemeinsame Aktivitäten und besondere Momente aufnehmen?"
        },
        "photo-books-mothers-day-how-far-back": {
          "content": "Es gibt keine feste Regel, wie weit du zurückgehen solltest. Kombiniere aktuelle und ältere Bilder, die eure Beziehung über die Zeit zeigen. Mit Mixtiles kannst du bis zu {{max_photos}} Fotos hochladen – genug Platz für eine umfassende Sammlung.",
          "title": "Wie weit in die Vergangenheit sollte ich gehen?"
        },
        "photo-books-mothers-day-quotes-messages": {
          "content": "Ja, Zitate oder herzliche Botschaften geben deinem Buch eine persönliche Note. Ob Mamas Lieblingsspruch oder ein Zitat, das zu eurer Beziehung passt – solche Details vertiefen die Emotion. Auf unserer Plattform lässt sich Text leicht neben Bildern platzieren.",
          "title": "Kann ich Zitate oder herzliche Botschaften hinzufügen?"
        },
        "photo-books-mothers-day-creation-steps": {
          "content": "Ein individuelles Muttertags‑Fotobuch zu erstellen ist unkompliziert: Lade mindestens 24 Fotos in unserer Website oder App hoch. Unsere Einzigartige Ein‑Tipp‑Erstellung ordnet sie für dich; anschließend kannst du weiter anpassen. Ist alles fertig, bestellst du direkt. Brauchst du Hilfe? Unser Support ist per E‑Mail oder Live‑Chat für dich da.",
          "title": "Welche Schritte sind nötig, um ein individuelles Buch zu erstellen?"
        },
        "photo-books-deals-current-available": {
          "content": "Bei Mixtiles gibt es regelmäßig tolle Angebote für Fotobücher, damit du bei persönlichen Erinnerungen sparen kannst. Meist liegen die Rabatte zwischen 15 % und 20 % und sind oft zu Saisonzeiten, Feiertagen oder bei Aktionen verfügbar. Das Beste: Du brauchst keinen Code zu suchen – eine aktive Aktion wird automatisch im Warenkorb angewendet. Fang einfach an zu gestalten und sieh den Rabatt an der Kasse.\n\nUnsere Fotobücher sind nicht nur wunderschön gefertigt, sondern dank Ein‑Tipp‑Erstellung auch superleicht zu machen. Lade deine Lieblingsmomente hoch, und wir ordnen sie zu einem bestellfertigen Buch – ganz ohne komplizierte Bearbeitung (außer du möchtest!).",
          "title": "Welche Fotobuch‑Angebote gibt es aktuell bei Mixtiles?"
        },
        "photo-books-deals-apply-promo-code": {
          "content": "Viele Angebote werden automatisch angewendet, gelegentlich erhältst du aber einen Promo‑Code per E‑Mail oder Social Media. So löst du ihn manuell ein:<ol><li>Tippe auf das Menü‑Symbol (☰) oben in unserer Website oder App.</li><li>Wähle Promo‑Code.</li><li>Klicke unten auf Code hinzufügen.</li><li>Gib den Code ein und bestätige mit Fertig.</li></ol>So einfach. Ist der Code aktiv, siehst du den Rabatt sofort im Warenkorb. Funktioniert er nicht, prüfe das Ablaufdatum und dass er nicht mit einem anderen Angebot kombiniert wird.",
          "title": "Wie löse ich einen Promo‑Code ein?"
        },
        "photo-books-deals-combine-multiple": {
          "content": "Pro Bestellung ist nur eine Aktion möglich. So sehr wir gute Deals lieben – Fotobuch‑Rabatte lassen sich nicht stapeln. Wenn du mehrere gültige Codes hast, heb dir den zweiten fürs nächste Buch auf.\n\nWir halten es einfach – genau wie unsere Bücher – ganz ohne Code‑Jonglieren für gute Preise.",
          "title": "Kann ich mehrere Angebote oder Codes kombinieren?"
        },
        "photo-books-deals-bigger-orders": {
          "content": "Unsere Preislogik ist anders. Mixtiles‑Fotobücher kosten einen festen Preis – unabhängig von der Seitenzahl. So kannst du mehr Erinnerungen hinzufügen, ohne Extrakosten zu fürchten.\n\nIm Gegensatz zu vielen Anbietern berechnen wir nicht pro Seite. Das macht die Preise einfach und transparent – weniger Bedarf für zusätzliche Mengenrabatte. Ob 20 oder 80 Fotos: Der Preis bleibt gleich.",
          "title": "Warum werden die Angebote bei größeren Bestellungen nicht besser?"
        },
        "photo-books-deals-stay-updated": {
          "content": "So bleibst du über Angebote auf dem Laufenden:<ul><li>Melde dich für unsere E‑Mails an unter <a href=\"https://www.mixtiles.com/getstarted\" target=\"_blank\" rel=\"noopener noreferrer\">www.mixtiles.com/getstarted</a></li><li>Folge uns auf Instagram und Facebook – dort teilen wir exklusive Deals</li></ul>Abonnent:innen erhalten oft frühen Zugang zu zeitlich begrenzten Aktionen. Ob du eine Reise drucken oder ein Geschenk erstellen willst – so verpasst du keinen guten Deal.",
          "title": "Wie bleibe ich über künftige Angebote informiert?"
        },
        "photo-books-christmas-why-make": {
          "content": "Mit einem Weihnachts‑Fotobuch bewahrst du festliche Erinnerungen in greifbarer Form. Wir bieten wunderschön gebundene Bücher, mit denen du jeden besonderen Moment neu erlebst – vom Baumschmücken bis zum Familienessen. Unsere Bücher sind mehr als Bildersammlungen: Sie sind Andenken, die die Freude und Wärme der Feiertage einfangen.",
          "title": "Warum ein Weihnachts‑Fotobuch machen?"
        },
        "photo-books-christmas-photos-include": {
          "content": "Ein Weihnachts‑Fotobuch sollte Momente deiner Feier einfangen: Baum schmücken, Geschenke öffnen, gemeinsame Essen. Diese Szenen gehören zum Weihnachtsgefühl – und auf unserem samtigen Papier mit Seiden‑Haptik leuchten sie in kräftigen Farben.",
          "title": "Welche Fotos gehören in ein Weihnachtsalbum?"
        },
        "photo-books-christmas-theme-book": {
          "content": "Ein Thema verleiht deinem Weihnachtsbuch zusätzliche Persönlichkeit. Beliebt sind z. B. \"Winter‑Wunderland\" mit verschneiten Landschaften und gemütlichen Innenaufnahmen oder \"Zuhause zu den Feiertagen\" mit herzerwärmenden Familienmomenten. Mit Mixtiles ordnest und thematisierst du deine Fotos genau nach deiner Vorstellung.",
          "title": "Wie vergebe ich ein Thema für ein Weihnachts‑Fotobuch?"
        },
        "photo-books-christmas-decorations-captions": {
          "content": "Mit weihnachtlichen Deko‑Elementen oder Bildunterschriften erzählst du deine Geschichte noch besser. Unsere einfachen Tools lassen dich jede Seite personalisieren – mit Texten oder Deko, die deine Fotos ergänzen. Ob festlicher Rahmen oder herzliches Zitat: Diese Details machen dein Buch noch besonderer.",
          "title": "Soll ich weihnachtliche Deko oder Bildunterschriften hinzufügen?"
        },
        "photo-books-christmas-snowy-outdoor-photos": {
          "content": "Ja, unbedingt! Schneebilder oder winterliche Außenaufnahmen bringen Abwechslung und Tiefe ins Buch. Unser Layout mit einem Foto pro Seite setzt auch kleine Details schön in Szene.",
          "title": "Kann ich Schnee‑ oder Outdoor‑Fotos aufnehmen?"
        },
        "photo-books-christmas-creative-ideas": {
          "content": "Für einen kreativen Touch nutze Sticker und Zitate. Unsere Tools helfen dir, persönliche Akzente zu setzen, die deine Feiertagsstimmung widerspiegeln. So wird dein Buch zu einem einzigartigen Weihnachts‑Meisterstück.",
          "title": "Welche kreativen Ideen gibt es für ein Weihnachts‑Fotobuch?"
        },
        "photo-books-christmas-meaningful-gift": {
          "content": "Ein Weihnachts‑Fotobuch ist ein bedeutungsvolles Geschenk: eine persönliche Sammlung von Erinnerungen, die man jahrelang schätzt. Mit dem schlanken, matten Hardcover eignen sich unsere Bücher perfekt, um Geschichten zu teilen – aufmerksam und von Herzen.",
          "title": "Wie ist ein Weihnachts‑Fotobuch ein besonderes Geschenk?"
        },
        "photo-books-christmas-creation-steps": {
          "content": "Ein Weihnachts‑Fotobuch mit Mixtiles zu erstellen ist einfach und intuitiv. Wähle ein Thema und deine Lieblingsfotos. Lade mindestens 24 Bilder hoch; unsere Ein‑Tipp‑Erstellung ordnet sie zu einem bestellfertigen Buch. Danach kannst du weiter anpassen, damit es eure festliche Geschichte widerspiegelt.",
          "title": "Welche Schritte brauche ich für ein Weihnachts‑Fotobuch?"
        },
        "photo-books-12x12-sizes-formats": {
          "content": "Wir bieten unsere Fotobücher in drei Größen an – darunter das beeindruckende Format {{size_display}}. Perfekt für alle, die einen starken, auffälligen Auftritt wollen. Unsere {{size_display}}‑Bücher haben ein elegantes, mattes Hardcover für Langlebigkeit und Stil.",
          "title": "Welche Größen und Formate gibt es für {{size_display}}‑Fotobücher?"
        },
        "photo-books-12x12-pages-contain": {
          "content": "Unsere {{size_display}}‑Bücher können zwischen 24 und {{max_photos}} deiner liebsten Erinnerungen zeigen – mit einem Foto pro Seite, damit jeder Moment im Rampenlicht steht. Ideal vom kurzen Event‑Überblick bis zur umfangreichen Sammlung.",
          "title": "Wie viele Seiten kann ein {{size_display}}‑Fotobuch haben?"
        },
        "photo-books-12x12-cover-materials": {
          "content": "Wir fertigen unsere {{size_display}}‑Bücher aus Premium‑Materialien: samtiges Papier mit lebendigen Farben, dazu eine Hardcover‑Decke mit dünner, matter Schutzfolie – robust und mit einem Hauch Raffinesse.",
          "title": "Welche Cover‑Materialien gibt es für {{size_display}}‑Bücher?"
        },
        "photo-books-12x12-lay-flat-hardcover": {
          "content": "Unsere Fotobücher sind Hardcover‑Bücher – stabil und langlebig zum Bewahren deiner Erinnerungen. Sie sind nicht lay‑flat, doch das Hardcover schützt und präsentiert deine Fotos sehr schön.",
          "title": "Sind {{size_display}}‑Fotobücher lay‑flat oder Hardcover?"
        },
        "photo-books-12x12-good-for": {
          "content": "Ein {{size_display}}‑Buch ist ideal als Coffee‑Table‑Buch – ein Blickfang, der Gäste zum Blättern einlädt. Das größere Format eignet sich für große Motive und detailreiche Bilder, die deine Geschichte eindrucksvoll erzählen.",
          "title": "Wofür eignet sich ein {{size_display}}‑Fotobuch besonders?"
        },
        "photo-books-12x12-compare-smaller": {
          "content": "Im Vergleich zu kleineren Größen bietet {{size_display}} mehr Fläche – perfekt für Details und umfassendes Storytelling. So wird jedes Detail sichtbar und wertgeschätzt.",
          "title": "Wie schneiden {{size_display}}‑Bücher im Vergleich zu kleineren ab?"
        },
        "photo-books-12x12-price-range": {
          "content": "Aufgrund der Größe und der Premium‑Materialien liegt das {{size_display}}‑Buch preislich meist über kleineren Formaten. Die Investition lohnt sich jedoch für alle, die ihre Erinnerungen wirkungsvoll und hochwertig präsentieren möchten.",
          "title": "Welche Preisspanne haben {{size_display}}‑Fotobücher?"
        },
        "photo-books-12x12-professional-portfolio": {
          "content": "Absolut! Unsere {{size_display}}‑Bücher eignen sich hervorragend für professionelle Alben oder Portfolios. Mit Premium‑Druck und anpassbaren Einstellungen präsentierst du Arbeiten und Projekte eindrucksvoll und hochwertig.",
          "title": "Eignet sich {{size_display}} für professionelle/Portfolio‑Alben?"
        },
        "photo-books-8x8-what-makes-special": {
          "content": "Ein {{size_display}}‑Fotobuch ist ein kompaktes Buch im quadratischen Format, das Lieblingsmomente wunderschön zeigt. Mixtiles kombiniert einen schlanken, matten Hardcover‑Einband mit Seiten aus samtigem Papier. Ideal für alle, die handliche Größe ohne Qualitätskompromisse möchten – zum Genießen bei jedem Umblättern.",
          "title": "Was ist ein {{size_display}}‑Fotobuch und was macht es besonders?"
        },
        "photo-books-8x8-mix-portrait-landscape": {
          "content": "Ja, du kannst Hoch‑ und Querformat mischen. Unsere Tools erlauben Zoomen, Zuschneiden und Neuordnen, damit alles ins Layout passt. Eine Seite, ein Foto – so bekommt jede Erinnerung ihr Rampenlicht.",
          "title": "Kann ich Hoch‑ und Querformat in einem {{size_display}} mischen?"
        },
        "photo-books-8x8-cover-options": {
          "content": "Unsere {{size_display}}‑Bücher haben ein hochwertiges, mattes Hardcover. Personalisiere das Cover mit einer besonderen Aufnahme und passe den \"Happy Moments\"‑Text an – für eine persönliche Note, die eure Geschichte auf den Punkt bringt.",
          "title": "Welche Cover‑Optionen gibt es für {{size_display}}‑Bücher?"
        },
        "photo-books-8x8-good-occasions": {
          "content": "Das Format {{size_display}} passt zu vielen Anlässen: Familientreffen, Urlaube, Hochzeiten oder Lebensmeilensteine. Die kompakte Größe macht es zum perfekten Andenken oder Geschenk – leicht zu teilen mit deinen Liebsten.",
          "title": "Für welche Anlässe eignet sich ein {{size_display}}‑Buch?"
        },
        "photo-books-8x8-pages-have": {
          "content": "Unsere {{size_display}}‑Bücher bieten Platz für 24 bis {{max_photos}} Seiten und damit für viele Erinnerungen. So erzählst du deine Geschichte – ob klein oder groß – genau so, wie du willst.",
          "title": "Wie viele Seiten kann ein {{size_display}} haben?"
        },
        "photo-books-8x8-square-format-display": {
          "content": "Ja, {{size_display}} ist quadratisch und lässt sich leicht auf Tischen, Regalen oder Schreibtischen präsentieren. Kompakt und stilvoll – ein vielseitiger Hingucker für jeden Raum.",
          "title": "Sind {{size_display}}‑Bücher quadratisch und leicht auszustellen?"
        },
        "photo-books-8x8-templates-styles": {
          "content": "Bei Mixtiles sorgt ein schlanker Ein‑Tipp‑Ablauf dafür, dass deine Fotos automatisch in ein stimmiges Layout kommen. Es gibt keine Vielzahl an Vorlagen, aber du kannst Reihenfolge und Zuschnitt mühelos anpassen, bis der Stil zu dir passt.",
          "title": "Welche Vorlagen oder Stile gibt es für {{size_display}}?"
        },
        "photo-books-8x8-why-choose": {
          "content": "{{size_display}} bietet die perfekte Balance aus Handlichkeit und Präsenz. Groß genug, um Fotos schön zu zeigen, kompakt genug für einfache Handhabung und Aufbewahrung. Ein vielseitiges Format, das überall gut wirkt.",
          "title": "Warum ein {{size_display}} statt einer größeren/kleineren Größe wählen?"
        },
        "photo-books-recipe-what-is": {
          "content": "Ein Rezept‑Fotobuch ist eine einzigartige, persönliche Art, Lieblingsrezepte zusammen mit tollen Fotos zu sammeln. Wie ein klassisches Kochbuch zeigt es sowohl die Rezepte als auch die Optik der Gerichte. Bei Mixtiles bieten wir elegante, schön gebundene Fotobücher, die deine kulinarische Sammlung in ein Andenken verwandeln. Mit unseren einfachen Tools kuratierst du ein Buch, das deine kulinarische Reise erzählt und beim Durchblättern Freude macht.",
          "title": "Was ist ein Rezept‑Fotobuch und wie nutzt man es?"
        },
        "photo-books-recipe-old-family-recipes": {
          "content": "Alte Familienrezepte einzubinden ist eine wunderbare Möglichkeit, kulinarische Traditionen zu bewahren. Scanne die handschriftlichen Rezepte und lade sie als Bilder hoch. Unsere Plattform lässt dich diese Scans nahtlos neben Fotos der fertigen Gerichte oder beim gemeinsamen Kochen platzieren – eine herzliche Verbindung von früher und heute.",
          "title": "Wie binde ich alte Familienrezepte ein?"
        },
        "photo-books-recipe-themes": {
          "content": "Themen gibt es ohne Ende: z. B. Festtagsrezepte für das Gefühl großer Runden, ein reines Dessert‑Buch mit süßen Highlights, oder Budget‑Gerichte, die günstig und lecker sind. Egal welches Thema – unsere Bücher sind die perfekte Leinwand für deine kulinarische Vision.",
          "title": "Welche Themen kann ich für ein Rezept‑Fotobuch nutzen?"
        },
        "photo-books-recipe-organize": {
          "content": "Organisiere, wie es dir liegt: chronologisch, um deine Entwicklung zu zeigen, oder nach Kategorien wie Vorspeisen, Hauptgerichte und Desserts. In Mixtiles kannst du Seiten und Fotos leicht umordnen – so wird dein Buch praktisch und schön zugleich.",
          "title": "Wie sollte ich die Rezepte im Buch anordnen?"
        },
        "photo-books-recipe-layout-details": {
          "content": "Jedes Rezept sollte einen klaren Titel, eine Zutatenliste, Schritt‑für‑Schritt‑Anleitung und passende Fotos enthalten. Unser Layout mit einer Foto‑pro‑Seite hebt die Schönheit jedes Gerichts hervor. Ergänze gern persönliche Notizen oder Tipps – das macht's noch spannender und hilfreicher.",
          "title": "Welche Layout‑Details braucht jedes Rezept?"
        },
        "photo-books-recipe-cooking-process-photos": {
          "content": "Auf jeden Fall! Fotos vom Kochprozess oder vom fertigen Gericht geben Tiefe und Kontext. Unsere Premium‑Bücher auf samtigem Papier lassen Farben und Details lebendig werden – für ein schönes Lese‑ und Blättererlebnis.",
          "title": "Kann ich Fotos vom Kochprozess oder Endergebnis hinzufügen?"
        },
        "photo-books-recipe-family-heirloom": {
          "content": "Ja, ein Rezept‑Fotobuch eignet sich hervorragend als Familienerbstück. Es bewahrt eure kulinarische Geschichte und kann über Generationen weitergegeben werden. Mit Rezepten und den Geschichten dahinter entsteht ein zeitloses Andenken. Unsere matten Hardcover sorgen für lange Haltbarkeit.",
          "title": "Ist ein Rezept‑Fotobuch ein gutes Familienerbstück?"
        },
        "photo-books-recipe-make-engaging": {
          "content": "Mach dein Buch lebendig: Füge persönliche Notizen, Anekdoten oder Profi‑Tipps zu jedem Rezept hinzu. Diese Elemente zeigen die Bedeutung der Gerichte und machen das Buch interaktiver. Personalisiere es, damit es deinen kulinarischen Weg widerspiegelt – so bleibt es allen, die es lesen, in bester Erinnerung.",
          "title": "Wie mache ich das Buch besonders ansprechend?"
        }
      },
      "fullscreen_title": "Drucke in Museumsqualität, direkt von Deinem Handy",
      "fullscreen_title_desktop": "Drucke in Museumsqualität",
      "made_in_canada": "Hergestellt in Kanada",
      "main_button_cta": "Jetzt loslegen",
      "photo_wall": {
        "subtitle": "Passe sie perfekt an Dein Zuhause an",
        "title": "Mit ein paar Klicks zur perfekten Fotowand"
      },
      "secondary_title_1": "Sag Hammer und Nagel ade",
      "secondary_title_1_desktop": "Einfach Schutzfolie abziehen und ankleben",
      "secondary_title_2": "Passe sie perfekt an ",
      "secondary_title_3": "Sie hinterlassen keine Spuren",
      "meet_magnetic_hanging": "Unser magnetisches Aufhängesystem",
      "seen-on": "Gesehen bei",
      "seen-on-desktop": "Gesehen bei",
      "simple_price": {
        "subtitle": "Unsere Preise sind fair, ohne versteckte Gebühren und der Versand ist immer kostenlos.",
        "title": "Gleicher Preis, egal wie viele Seiten"
      },
      "simple_price_tiers": {
        "from_label": "Ab",
        "subtitle": "Unsere Bücher haben einfache Preisstufen nach Größe und Seitenzahl, mit kostenlosem Versand.",
        "title": "Einfache Preise, Keine Überraschungen"
      },
      "title": "Fotowände neu erfunden",
      "try_now": {
        "continue": "Mit dem Buch fortfahren",
        "subtitle": "Gestalte Dein Buch mit nur wenigen Klicks und lasse es in 3D zum Leben erwachen",
        "title": "Fotobücher leicht gemacht",
        "design_subtitle": "Verwandle deine Reisen in atemberaubende Bildbände mit wenigen Klicks",
        "design_title": "Reisebücher Leicht Gemacht",
        "life_events_subtitle": "Verwandle deine größten Lebensmomente mit wenigen Klicks in Bildbände.",
        "life_events_title": "Ein schönes Buch für jeden Meilenstein",
        "create_now": "Jetzt erstellen"
      },
      "email_signup": {
        "title": "Erfahren Sie als Erster von Angeboten, Neuigkeiten und Dekorationsideen.",
        "email_label": "E-Mail-Adresse",
        "terms_text": "Durch Ihre Anmeldung geben Sie Ihre Einwilligung zu den Nutzungsbedingungen und der Datenschutzrichtlinie von Mixtiles",
        "success_message": "Vielen Dank für Ihr Abonnement"
      }
    },
    "login": {
      "last_used": "Zuletzt verwendet",
      "continue_with": "Weitermachen mit",
      "create_account_error": "Fehler beim Erstellen des Accounts",
      "error_dialog": {
        "incorrect_email_or_code_message": "Die E-Mail oder der Code ist falsch. Bitte gib den Code erneut ein oder versuche es mit einer anderen E-Mail.",
        "incorrect_email_or_code_title": "Falsche E-Mail oder Code",
        "login_unsuccessful_message": "Bitte versuche es erneut oder kontaktiere den Support",
        "login_unsuccessful_title": "Login fehlgeschlagen",
        "too_many_incorrect_attempts_message": "Bitte prüfe deine E-Mail, um dein Konto freizuschalten.",
        "too_many_incorrect_attempts_title": "Zu viele Fehlversuche"
      },
      "email_capture_placeholder": "E-Mail-Adresse eingeben",
      "email_code": {
        "code_sent": "Code per E-Mail verschickt",
        "code_sent_detailed": "Der Code wurde an folgende E-Mail-Adresse geschickt: {{email}}",
        "resend_code": "Code erneut senden",
        "resend_code_countdown": "Erneut senden in {{seconds}} s",
        "enter_code": "Code eingeben"
      },
      "login": "Einloggen",
      "login_message": "{{v1}} um Bestellungen zu bearbeiten und zu verfolgen",
      "login_or_sign_up": "Einloggen oder registrieren",
      "login_successfully": "Super! Du bist eingeloggt",
      "no_email_error": "Um einen Account zu erstellen, brauchen wir Deine E-Mail-Adresse",
      "register_successfully": "Hey! Registrierung abgeschlossen",
      "restored_photo": "Dein gespeichertes Bild wurde wiederhergestellt",
      "restored_photos": "Deine gespeicherten Bilder wurden wiederhergestellt",
      "restricted": {
        "title": "Melde dich an, um deine Bestellungen zu sehen"
      },
      "sign_out": "Ausloggen",
      "sign_up": "Registrieren",
      "start_your_design_journey": "Starte Deine Design-Reise!",
      "terms_of_use": {
        "and": "und",
        "privacy_policy": "Datenschutzerklärung",
        "terms_of_use": "AGB",
        "terms_of_use_intro": "Mit der Registrierung erklärst Du Dich mit unseren {{v1}} einverstanden"
      },
      "verify_email_dialog": {
        "button": "Später",
        "content": "Wir haben Dir eine Mail an {{v1}} zur Bestätigung geschickt, um Dein Benutzerkonto zu aktivieren. Hier siehst Du dann Deine Bestellungen.",
        "title": "Schau in Dein Postfach"
      }
    },
    "logout": {
      "signed_out_successfully": "Erfolgreich abgemeldet",
      "signed_out_successfully_subtitle": "Melde dich wieder an, um deine gespeicherten Bilder zu sehen"
    },
    "multi_product_homepage": {
      "photo_walls_title": "Fotowände",
      "photo_walls_subtitle": "Verwandle Deine Fotos in tolle Wandkunst",
      "photo_books_subtitle": "Gestalte Dein Buch mit wenigen Klicks",
      "pet_portraits_subtitle": "Lustige & künstlerische Porträtfotos",
      "shop_now": "Jetzt kaufen",
      "continue_designing": "Weiter gestalten",
      "explore_now": "Entdecken",
      "download": "Herunterladen",
      "app_title": "Die neue Mixtiles App",
      "app_subtitle": "Wir verwandeln Deine schönsten Momente automatisch in fertige Fotoprodukte",
      "app_store_badge": "Laden im App Store",
      "get_app_title": "Hol dir die neue Mixtiles App",
      "new_products_title": "Probiere unsere neuen Produkte",
      "desktop_new_products_title": "Produkte",
      "new_products": {
        "caricature": "Karikatur",
        "the_studio": "Studiofotos"
      },
      "best_place_title": "Die beste Wahl für Deine Fotodrucke",
      "stats": {
        "rating_caption": "156K+ Bewertungen",
        "customers_caption": "Zufriedene Kunden"
      },
      "desktop_stats": {
        "photos_printed_caption": "Gedruckte Fotos"
      }
    },
    "my_orders": {
      "active_orders": "Offene Bestellungen",
      "completed_orders": "Abgeschlossene Bestellungen",
      "no_orders_button": "Such Dir Fotos aus",
      "no_orders_title": "Wir haben noch keine Bestellungen für Dich gefunden.",
      "resend_email": "E-Mail erneut senden",
      "verify_email": "E-Mail-Adresse bestätigen"
    },
    "new_email_capture": {
      "a_box_of_mixtiles": {
        "subtitle": "Fotos selbst hochladen",
        "title": "Ein Paket Mixtiles",
        "tiles_or_book": "Tiles oder ein Fotobuch"
      },
      "agree_to_emails": "Ja, bitte sendet mir Informationen und neue Angebote",
      "agree_to_emails_sign_now": "Jetzt anmelden, um exklusive Angebote zu erhalten, inspiriert zu werden, und unsere neuen Produkte zu entdecken ",
      "attribution": {
        "channels": {
          "email": "E-Mail",
          "facebook": "Facebook",
          "flyer": "Flyer",
          "friend": "Freunde",
          "game": "Handyspiel",
          "google": "Google",
          "instagram": "Instagram",
          "other": "Andere",
          "pinterest": "Pinterest",
          "snapchat": "Snapchat",
          "stacey_solomon": "Stacey Solomon",
          "rebecca_judd": "Rebecca Judd",
          "tammin_sursok": "Tammin Sursok",
          "tia_mowry": "Tia Mowry",
          "tv": "Fernsehen",
          "youtube": "Youtube",
          "airport": "Flughafen",
          "podcast": "Podcast",
          "shorts": "Shorts",
          "tiktok": "TikTok",
          "twitter": "Twitter"
        },
        "help_us_improve": "Hilf uns, uns zu verbessern!",
        "sub_options": {
          "influencer": "Ein Influencer/ Eine Influencerin",
          "not_sure": "Ich bin mir nicht sicher",
          "paid_ad": "Bezahlte Werbung"
        },
        "title": "Woher kennst Du Mixtiles?"
      },
      "continue": "Weiter",
      "disagree_to_emails": {
        "emphasized": "keine",
        "text": "Ich möchte {{emphasized}} Marketingemails von Mixtiles erhalten"
      },
      "email_placeholder": "Deine E-Mail-Adresse",
      "for_gift": "Für Andere",
      "for_gift_subtitle": "Zum Verschenken",
      "for_me": "Für mich!",
      "for_me_subtitle": "Ich dekoriere mein Zuhause",
      "gift_card": {
        "subtitle": "Der/Die Beschenkte darf sich die Fotos selbst aussuchen",
        "title": "Gutschein"
      },
      "gift_question": "Welche Art von Geschenk?",
      "intro": {
        "title": "Willkommen bei Mixtiles. Lass uns loslegen!"
      },
      "lets_create": "Lass uns loslegen!",
      "name_placeholder": "Wie heißt Du?",
      "privacy_disclaimer": "Mit dem Abschicken, erklärst Du Dich mit den  {{v1}} & {{v2}} einverstanden",
      "sms_privacy_disclaimer_consent": "Mit Angabe Ihrer Nummer stimmen Sie dem Erhalt von Angeboten per SMS und Messaging-Apps gemäß unserer Datenschutzerklärung zu. Abmeldung jederzeit durch Antwort mit STOP oder Klick auf den Abmeldelink möglich.",
      "sms_step_label": "Wie lautet Deine Handynummer?",
      "sms_step_title": "Erhalte Infos zu exklusive Angeboten und Sales direkt auf dein Handy",
      "title": "Hi {{v1}}!",
      "title_no_name": "Hi!",
      "who_for": "Für wen soll's sein?",
      "sms_privacy_disclaimer": "Mit der Eingabe deiner Telefonnummer stimmst du zu, Marketingnachrichten an die angegebene Nummer zu erhalten. Die Zustimmung ist keine Kaufbedingung. Es können Nachrichten- und Datengebühren anfallen. Die Nachrichtenfrequenz variiert. Antworte HELP für Hilfe oder STOP zum Abbestellen. Sieh dir unsere {{v1}} und {{v2}} an "
    },
    "order": {
      "canada_tariff_notice_bag": "Leinwanddrucke & Fotobücher sind zollfrei",
      "canada_tariff_notice_tiles": "Leinwanddrucke sind zollfrei",
      "add_photos": "Fotos hinzufügen",
      "add_photos_count": "Füge {{v1}} Fotos hinzu",
      "add_photos_single": "Füge 1 Foto hinzu",
      "add_to_bag": "In den Warenkorb",
      "art": "Kunst",
      "art_orientation_warning": {
        "checkout": {
          "label": {
            "singular": "Kunst sieht vertikal am besten aus."
          }
        }
      },
      "checkout": {
        "add_address": "Adresse eingeben",
        "add_gift_note": "Meinen Gruß hinzufügen",
        "add_gift_note_options": {
          "close": "Schließen",
          "description": "Wir packen Deinen Gruß dazu (statt des Lieferscheins)",
          "edit_note": "Gruß bearbeiten oder löschen",
          "edit_options": {
            "dismiss": "Abbrechen",
            "edit": "Bearbeiten",
            "remove": "Löschen"
          },
          "header": "Meinen Gruß hinzufügen",
          "placeholder": [
            "Hi!",
            "",
            "Ich hoffe, Du wirst dieses Bild genauso lieben wie ich!",
            "",
            "Alles Liebe",
            "Ich"
          ],
          "start_writing": "Gruß schreiben"
        },
        "add_payment": "Zahlungsart angeben",
        "add_payment_options": {
          "credit_card_ends_with": "Endziffern {{v1}}",
          "paying_with": "Mit {{v1}} zahlen"
        },
        "are_you_sure": "Bist Du sicher?",
        "change_info": "Ändern",
        "confirm_button_text_gdpr": "Kostenpflichtig bestellen",
        "confirm_button_text_non_gdpr": "Bestellung abschicken",
        "gift_note_added": "Gruß hinzugefügt",
        "minimum_order_fee": {
          "description": "Mindestbestellmenge: {{v1}}. Wird diese nicht erreicht, müssen wir die Differenz berechnen.",
          "title": "Mindestbestellgebühr"
        },
        "no_go_back": "Nein, doch nicht",
        "payment_errors": {
          "add_new_card": "Karte hinzufügen",
          "authentication_failed_text": "Wir konnten Deine Karte nicht prüfen. Bitte versuch es mit einer anderen Karte.",
          "authentication_failed_title": "Prüfung fehlgeschlagen",
          "card_declined_text": "Wir konnten Deine Karte nicht belasten. Bitte versuch es mit einer anderen Karte.",
          "card_declined_text_1": "Deine Karte wurde abgelehnt. Bitte prüfe Deine Kartendaten.",
          "card_declined_text_2": "Wenn alles stimmt, kontaktiere Deine Bank und versuche es erneut.",
          "card_declined_title_2": "Die Buchung hat nicht geklappt",
          "charge_failed_text": "Es tut uns Leid, aber wir konnten die Buchung nicht abschließen. Bitte versuch es mit einer anderen Karte.",
          "charge_failed_title": "Buchung fehlgeschlagen",
          "incomplete_photo_wall": {
            "missing_photos_plural": "Deinem Fotowand fehlen {{v1}} Fotos",
            "missing_photos_singular": "Deinem Fotowand fehlt 1 Foto"
          },
          "invalid_email_text": "Bitte gib deine E-Mail-Adresse erneut ein, damit wir deine Bestellung abschließen können.",
          "invalid_email_title": "Bitte gib deine E-Mail ein",
          "no_charge_text": "Keine Sorge, Dir wurde nichts berechnet!",
          "no_tiles_selected": "Keine Bilder ausgewählt",
          "oops_order_failed": "Ups, das hat leider nicht geklappt",
          "order_error_text": "Leider konnten wir Deine Bestellung nicht abschließen. Probier's nochmal oder schreib uns!",
          "order_error_title": "Bestellung fehlgeschlagen",
          "payment_error_text": "Leider konnten wir Deine Bestellung nicht verarbeiten, weil die Zahlung fehlgeschlagen ist. Probier's nochmal oder schreib uns!",
          "payment_error_title": "Zahlung fehlgeschlagen",
          "uploads_failed_text": "Der Upload Deiner Bilder ist fehlgeschlagen. Bitte wiederhole den Vorgang.",
          "order_price_calculation": {
            "subtitle": "Bitte aktualisiere die Seite. Keine Sorge, deine Fotos werden gespeichert.",
            "title": [
              "Tut uns leid, es gab ein Problem",
              "bei der Preisberechnung"
            ]
          }
        },
        "payment_methods": "Zahlungsarten",
        "payment_summary_rows": {
          "add_many_more_to_get_discount": "Such noch {{v1}} Bilder aus, um  {{v2}}% Rabatt auf die gesamte Bestellung zu bekommen. ",
          "add_more_to": {
            "get_more_many": "Noch {{v1}} für {{v2}} Gratisbilder",
            "get_more_one": "Noch {{v1}} für ein Gratisbild"
          },
          "add_one_more_to_get_discount": "Such noch ein Bild aus, um  {{v1}}% Rabatt auf die gesamte Bestellung zu bekommen. ",
          "add_one_to": {
            "get_more_many": "Füge noch ein Bild hinzu, um {{v2}} umsonst zu bekommen",
            "get_more_one": "Füge noch ein Bild hinzu, um eins gratis zu bekommen!"
          },
          "are_free": "{{v1}} davon gratis",
          "base_price_many": "{{v1}} Bilder á {{v2}}",
          "bundle_action": {
            "add_another_many": "füge noch {{v1}} Bilder für mehr Rabatt hinzu!",
            "add_another_one": "füge noch ein Bild für mehr Rabatt hinzu!",
            "add_many": "füge für den Rabatt noch {{v1}} Bilder hinzu!",
            "add_many_short": "noch {{v1}} Bilder bis zum Rabatt",
            "add_one": "füge für den Rabatt noch ein Bild hinzu!",
            "add_one_short": "noch 1 Bild bis zum Rabatt",
            "get_next_bundle": "hol dir {{v1}} für {{v2}}",
            "perfect": "Perfekt! Du sparst {{v1}}."
          },
          "bundle_change_to_size": "Der Promocode gilt nur für die Größe {{v1}}",
          "buy_over_percent_off_orders": "{{v1}}% Rabatt auf Bestellungen",
          "buy_over_percent_off_orders_over_price": "{{v1}}% Rabatt auf Bestellungen über {{v2}}",
          "buy_over_price_applied": "Juhu! Du sparst {{v1}}%",
          "buy_over_price_applied_saved": "Juhu! Du sparst {{v1}}",
          "discount_percentage_literal": "Du sparst {{v1}}%",
          "buy_over_price_buy_more": "Füge für den Rabatt noch {{v1}} hinzu.",
          "buy_over_price_buy_more_short": "noch {{v1}} bis zum Rabatt",
          "buy_over_tier": "{{v1}}% Rabatt ab {{v2}}",
          "buy_over_tiers_pair": "{{v1}} • {{v2}}",
          "buy_x_get_y": "Nimm {{v1}} krieg {{v2}} gratis",
          "buy_x_get_y_action": {
            "get_more_many": "Du kannst noch {{v1}} Gratisbilder hinzufügen!",
            "get_more_one": "Noch ein Gratisbild!",
            "saved": "Juhuuu, {{v1}} gespart!",
            "yay_get_many": "Cool, die nächsten {{v1}} sind gratis!",
            "yay_get_one": "Cool, Dein nächstes Bild ist gratis!"
          },
          "can_add_free_tiles": "Du kannst noch {{v1}} Gratisbilder hinzufügen!",
          "can_add_one_free_tile": "Noch ein Gratisbild!",
          "canvas_tile": "1 Leinwand",
          "canvas_tiles": "{{v1}} Leinwände",
          "color_tiles": "{{v1}} {{color}} Bilder",
          "delivery_by": "Lieferung bis",
          "discount": "Rabatt",
          "discount_off_over_price": "{{v1}}% Rabatt ab {{v2}}",
          "discount_off_over_price_short": "{{v1}}% Rabatt ab {{v2}}",
          "discount_percentage": "{{v1}}% Rabatt",
          "discounts_applied": "{{v1}} angewendet",
          "eligible_free_shipping": "Zu dieser Bestellung gibt es kostenlosen Versand",
          "eligible_free_shipping_over": "Kostenloser Versand für Bestellungen über {{v1}}",
          "free": "GRATIS",
          "free_shipping": "Kostenloser Versand",
          "free_shipping_over": "Kostenloser Versand ab {{v1}}",
          "free_tiles_many": "{{v1}} Gratisbilder",
          "free_tiles_single": "1 Gratisbild",
          "is_free": "1 davon gratis",
          "all_free": "kostenlos",
          "many_tiles": "{{v1}} Bilder",
          "mixed_frames": "gemischte Rahmen",
          "mixed_sizes_and_frames": "gemischte Größen & Rahmen",
          "more_tiles_many": "Noch {{v1}} Bilder",
          "more_tiles_one": "Noch 1 Bild",
          "more_tiles_with_each_price": "Noch {{v1}} Bilder á {{v2}}",
          "one_color_tile": "1 {{color}} Bild",
          "one_tile": "1 Bild",
          "photo_book_description_plural": "Fotobücher ({{v1}} Seiten)",
          "photo_book_description_singular": "Fotobuch ({{v1}} Seiten)",
          "sales_tax": "Steuer",
          "select_more_tiles_many": "Such Dir noch {{v1}} Bild aus",
          "select_more_tiles_one": "Such Dir noch ein Bild aus",
          "select_some_tiles": "Such Dir Fotos aus",
          "shipping": "Lieferung ",
          "subtotal": "Zwischensumme",
          "tax": "Steuer",
          "tiles_count": "{{v1}} Bilder",
          "tiles_size_many": "{{v1}} Bilder für {{v2}}",
          "total": "Summe",
          "wall_sign": "Hauptbild",
          "wall_signs": "Hauptbilder",
          "wide_frame_tile": "1 {{color}} Bild mit breitem Rahmen",
          "wide_frame_tiles": "{{v1}} {{color}} Bilder mit breitem Rahmen",
          "will_be_free_many": "{{v1}} Gratisbilder",
          "will_be_free_one": "Eins ist gratis!",
          "creditUsed": "Guthaben",
          "discount_percentage_automatic": "{{v1}}% Rabatt auf Fotobücher",
          "import_fee": "Importgebühr",
          "international_taxes": "Lokale Steuern",
          "many_books": "{{v1}} Bücher,{{v2}}"
        },
        "promo": {
          "cancel": "Promocode löschen",
          "free_tiles": "Gratisbilder",
          "free_books": "Kostenlose Fotobücher",
          "title": "Promocode",
          "yes_remove": "Ja, Promocode entfernen"
        },
        "shipping_options": {
          "calculating_delivery_date": "Lieferdatum wird berechnet...",
          "delivery_by": "Lieferung bis {{v1}}",
          "express_new_version": "Expressversand - {{v1}}",
          "express_name": "Expressversand",
          "priority": "Prioritätsversand - {{v1}}",
          "priority_name": "Prioritätsversand",
          "standard": "Standard Gratisversand",
          "estimated_delivery": "Vorr. {{v1}}"
        },
        "tokushoho_disclaimer": "返品・キャンセル条件／特定商取引法に基づく表記",
        "gift_card_available_credits": "{{v1}} verfügbar",
        "gift_card_credits": "Geschenkkarten-Guthaben",
        "gift_card_remove_title": "Möchtest du deine Geschenkkarte wirklich entfernen?"
      },
      "add_product": "Produkt hinzufügen",
      "cart_title": "Mein Warenkorb",
      "cart_volume_discount": "MENGENRABATT",
      "cart_add_promo": "Promo hinzufügen",
      "cart_change_promo": "Promo ändern",
      "cart_free_shipping_applied": "Kostenloser Versand inklusive",
      "cart_bag": "Warenkorb",
      "empty_bag_title": "Dein Warenkorb ist leer",
      "empty_bag_cta": "Jetzt kaufen",
      "cart_edit": "Bearbeiten",
      "cart_header": {
        "photo_book": "Fotobuch",
        "tiles_one": "1 Bild",
        "tiles_other": "{{count}} Bilder"
      },
      "cart_summary": {
        "tiles_one": "{{count}} Bild",
        "tiles_other": "{{count}} Bilder",
        "wall_signs_one": "{{count}} Hauptbild",
        "wall_signs_other": "{{count}} Hauptbilder",
        "with_size": "{{item}}, {{size}}",
        "frame_breakdown_row_one": "{{count}} {{frame}} Bild, {{size}}",
        "frame_breakdown_row_many": "{{count}} {{frame}} Bilder, {{size}}",
        "canvas_breakdown_row": "{{count}} {{frame}}, {{size}}",
        "frame_tiles_one": "{{count}} {{frame}} Bild",
        "frame_tiles_many": "{{count}} {{frame}} Bilder",
        "canvas_tiles": "{{count}} {{frame}}",
        "combined_no_size": "{{tiles}} und {{signs}}",
        "mixed_sizes_lower": "gemischte Größen",
        "mixed_frames": "Gemischte Rahmen",
        "photo_book": "Fotobuch, {{size}}",
        "book_with_pages": "Buch, {{size}}, {{pageCount}} Seiten"
      },
      "checkout_button_text": "Zur Kasse",
      "choose_from_phone": "Deine Fotos",
      "done": {
        "confirmation_email": "Deine Bestellbestätigung kommt gleich.",
        "delivery_time": "Deine Lieferung kommt bis zum {{v1}}",
        "next": "Weiter",
        "please_hold": "Das hat wunderbar geklappt! Wir machen uns jetzt an die Bearbeitung Deiner Bestellung, warte kurz. ",
        "will_receive_email": "Deine Bestellbestätigung geht gleich an",
        "woohoo": "Juhuuuu, geschafft!"
      },
      "faces_cropped_warning": {
        "cart_cta": "Prüfen & anpassen",
        "cart_label": "Gesicht abgeschnitten.",
        "cta": {
          "change_size": "Größe ändern",
          "crop": "Bildausschnitt anpassen"
        },
        "label": "Einige Gesichter sind abgeschnitten",
        "notification": {
          "change_size": {
            "cta": "Rückgängig",
            "title": "Größe geändert auf {{size}}"
          },
          "crop": {
            "cta": "Rückgängig",
            "title": "Bildausschnitt wurde angepasst"
          }
        }
      },
      "filters": {
        "dramatic": "Dramatisch",
        "noir": "Noir",
        "none": "Kein Filter",
        "painting": "Gemälde",
        "painting2": "Gemälde 2",
        "pencil": "Stift",
        "pencil2": "Stift 2",
        "silver": "Silber",
        "sketch": "Zeichnung",
        "sketch2": "Zeichnung 2",
        "vivid": "Lebendig",
        "winter": "Winter",
        "b_n_w": "S&W",
        "b_n_w2": "S&W2",
        "original": "Original",
        "vivid2": "Vivid 2"
      },
      "frame_colors": {
        "black": "Schwarz",
        "none": "Ungerahmt",
        "red_ash_wood": "Walnuss",
        "white": "Weiß",
        "wood": "Eichenholz"
      },
      "frame_presets": {
        "earthy_blend": "Naturmix",
        "classic_blend": "Klassikmix",
        "harmony_mix": "Harmoniemix"
      },
      "import_from_google_photos": "Von Google Fotos importieren",
      "low_quality_warning": {
        "action_keep": "Ich will's trotzdem",
        "action_remove": "Oh, dann lieber nicht",
        "banner": {
          "cta": "Fotos bestätigen",
          "text": "Diese Fotos haben eine niedrigere Auflösung als empfohlen und können im Druck verschwommen aussehen.",
          "title": "Fotos mit niedriger Auflösung überprüfen"
        },
        "text": "Dieses Foto ist ziemlich klein und wird wahrscheinlich unscharf aussehen!",
        "title": "Niedrige Auflösung",
        "warning": {
          "cta": "Austauschen",
          "cta_try_in_size": "{{sizeName}} ausprobieren",
          "label": "Bild mit niedriger Auflösung"
        }
      },
      "materials": {
        "canvas": "Leinwand",
        "classic": "Rahmen",
        "frameless": "Ungerahmt",
        "wide_frame": "Breiter Rahmen",
        "sticker": "Sticker"
      },
      "materials_detailed_descriptions": {
        "canvas": "Premium Leinwand mit wertigem Look. Auf Baumwolle gedruckt, mit magnetischer Befestigung.",
        "classic": "Hochwertige Aufmachung, im klassischen Look. Gedruckt auf Premiumpapier, mit magnetischer Befestigung.",
        "frameless": "Minimalistisches, modernes Design. Auf Premiumpapier gedruckt, mit magnetischer Befestigung.",
        "wide_frame": "Kühne Eleganz, für einen bleibenden Eindruck. Auf Premiumpapier gedruckt, mit magnetischer Befestigung."
      },
      "materials_plural": {
        "classic": "Rahmen",
        "wide_frame": "Breite Rahmen"
      },
      "mats": {
        "deep": "Breit",
        "medium": "Mittel",
        "none": "Kein Rand",
        "shallow": "Schmal",
        "heart": "Herz",
        "round": "Rund"
      },
      "promo_code_errors": {
        "messages": {
          "already_a_user": "Hi! Dieser Code ist nur für Neukunden, tut uns Leid!",
          "already_registered": "Ups, der Code wurde bereits angewendet.",
          "default": "Hmpf, es sieht aus als gäbe es diesen Code nicht. Sorry!",
          "expired": "Oh je, der Code ist bereits abgelaufen. Tut uns Leid!",
          "non_existing": "Hmpf, es sieht aus als gäbe es diesen Code nicht. Sorry!",
          "quantity_exceeded": "Dieser Code wurde bereits eingegeben! Du musst das also nicht erneut tun. Geh einfach zum Gerät, wo Du ihn zuerst eingegeben hast, und zur Kasse. Deine kostenlosen Bilder sind dann sichtbar.",
          "redemptions_per_customer_exceeded": "Ups, dieser Code wurde schon genutzt, sorry!",
          "self_referral": "Dieser Code ist für Deine für Mixtiles geworbenen Freunde.",
          "server_error": "Wir konnten Deinen Code nicht einlösen. Schreibst Du uns kurz, bitte?"
        },
        "titles": {
          "gift_card_empty": "Diese Geschenkkarte wurde vollständig eingelöst",
          "gift_card_inactive": "Diese Geschenkkarte ist nicht aktiv"
        }
      },
      "styles": {
        "mixed_styles": "Gemischt"
      },
      "tile_actions": {
        "adjust": "Bildausschnitt anpassen",
        "remove": "Löschen",
        "remove_photo": "Foto entfernen",
        "replace": "Foto austauschen",
        "replace2": "Austauschen",
        "replace_subtitle": "Wähle ein vorhandenes Foto oder lade ein neues hoch"
      },
      "upload_failed": {
        "action_continue": "Weiter",
        "format_not_supported": "Einige Dateien werden nicht unterstützt. Bitte in JPG oder PNG umwandeln.",
        "text": "Leider gab es ein Problem beim Hochladen Deines Bildes. Bitte versuche es erneut oder mit einem anderen Bild.",
        "title": "Upload fehlgeschlagen"
      },
      "upload_photo": "Fotos hochladen",
      "upload_photos": "Fotos hochladen",
      "what_to_add": "Was möchtest Du Deiner Bestellung hinzufügen?",
      "incomplete_collage_warning": {
        "label": "Der Collage fehlen Fotos."
      },
      "ai_tile_generating_warning": {
        "label": "Dein neuer Stil wird noch erstellt.",
        "cta": "Ansehen",
        "popup_subtitle": "Du kannst bezahlen, sobald er fertig ist."
      },
      "list_discount": {
        "banner": "Presidents' Day: {{v1}}% Rabatt auf Fotobücher"
      },
      "remove_item_popup": {
        "title": "Möchtest du es wirklich löschen?",
        "tiles": "Deine erstellten Bilder werden gelöscht",
        "photo_book": "Dein erstelltes Fotobuch wird gelöscht",
        "delete": "Löschen"
      }
    },
    "cart_upsells": {
      "bath_time": {
        "card_title_dog": "Mach deinen Hund zu lustiger Badekunst!",
        "card_title_cat": "Mach deine Katze zu lustiger Badekunst!",
        "card_cta": "Jetzt ansehen",
        "flow_title": "Badezeit"
      },
      "card_dismiss": "Ausblenden",
      "wall_subtitle_one": "{{count}} Bild, {{size}}",
      "wall_subtitle_other": "{{count}} Bilder, {{size}}",
      "add_tiles_one": "{{count}} Bild hinzufügen",
      "add_tiles_other": "{{count}} Bilder hinzufügen",
      "select_tiles_to_add": "Wähle Bilder zum Hinzufügen",
      "select_tiles_to_continue": "Wähle Bilder zum Fortfahren",
      "wall_tile": "Bild {{position}}"
    },
    "order_management": {
      "actions": {
        "change_address": "Adresse ändern",
        "edit_order": "Bestellung bearbeiten",
        "duplicate_order": "Bestellung duplizieren",
        "tracking_details": {
          "base": "Sendungsverfolgung",
          "not_shipped_suffix": "sobald versandt"
        },
        "edit_order_dialog": {
          "title": "Stornieren und bearbeiten?",
          "subtitle": "Stornieren und bearbeiten stoppt deine Bestellung, damit du sie aktualisieren kannst.",
          "refund_info": "Du erhältst ein Guthaben von {{v1}}, das du beim Bezahlen verwenden kannst. Um stattdessen eine Rückerstattung zu erhalten, kontaktiere den Support nach der Stornierung.",
          "button": "Bestellung stornieren und bearbeiten",
          "go_back": "Bestellung behalten"
        },
        "view_order_summary": "Bestellzusammenfassung ansehen"
      },
      "already_shipped_dialog": {
        "cancel_text": "Diese Bestellung ist bereits in der Produktion und kann nicht mehr storniert werden.",
        "cancel_title": "Zu spät zum Stornieren",
        "update_text": "Diese Bestellung ist bereits in der Produktion und kann nicht mehr geändert werden.",
        "update_title": "Zu spät zum Bearbeiten",
        "ok": "Alles klar"
      },
      "got_it": "Alles klar",
      "modifying_existing_order_dialog": {
        "ok": "Alles klar",
        "text": "Änderungen können Auswirkungen auf das Lieferdatum haben",
        "title": "Bestehende Bestellung bearbeiten"
      },
      "order_card": {
        "created_at": "Erstellt am",
        "delivered_at": "Geliefert am",
        "expected_arrival": "Vorauss. Lieferung",
        "number_of_photo_books": "Anzahl der Fotobücher",
        "number_of_tiles": "Anzahl",
        "order_number_prefix": "Bestellung"
      },
      "order_processing": {
        "cant_view_file": "Download nicht möglich. Versuche einen anderen Browser"
      },
      "order_processing_dialog": {
        "text": "Deine Bestellung ist in Bearbeitung. Versuch's in ein paar Minuten noch einmal!",
        "title": "In Bearbeitung"
      },
      "statuses2": {
        "approved": "In Produktion",
        "cancelled": "Storniert",
        "complete": "Geliefert",
        "processing": "In Druck",
        "shipped": "Versandt"
      },
      "title": "Deine Bestellung"
    },
    "out_of_stock": {
      "applied_to_other_materials": "Zu anderen Bildarten hinzugefügt",
      "applied_to_x": "Hinzugefügt zu {{v1}}",
      "applied_where_available": "Hinzugefügt, sofern verfügbar",
      "available_in_other_materials": "Verfügbar in anderen Materialien",
      "available_in_other_sizes": "Verfügbar in anderen Größen",
      "only_available_for_x": "Nur für {{v1}} verfügbar",
      "some_tiles_arent_available_for_this_option": "Manche Bilder sind in dieser Option nicht verfügbar.",
      "undo": "Rückgängig",
      "we_changed_some_frame_that_werent_available": "Ein paar Bilder die so nicht verfügbar waren, wurden geändert.",
      "x_isnt_available_in_x": "{{v1}} nicht in {{v2}} verfügbar",
      "x_isnt_available_size_changed_to_x_subtitle": [
        "Größe geändert auf {{v1}}"
      ],
      "x_isnt_available_size_changed_to_x_title": [
        "{{v1}} nicht verfügbar"
      ],
      "x_only_available_in_x": "{{v1}} nur als {{v2}} verfügbar",
      "x_x_isnt_available": "{{v1}} {{v2}} nicht verfügbar",
      "x_x_isnt_available_color_changed_to_x_subtitle": [
        "Farbe geändert zu {{v1}}"
      ],
      "x_x_isnt_available_color_changed_to_x_title": [
        "{{v1}} {{v2}} nicht verfügbar"
      ],
      "x_available_in_selected_materials": "{{v1}} in ausgewählten Materialien verfügbar"
    },
    "photo": {
      "edit_tile": "Bild bearbeiten",
      "photo_tiles": "Bilder"
    },
    "photo_book": {
      "product_names": {
        "newborn": "Neugeborenen-Fotobuch",
        "family": "Familien-Fotobuch",
        "annual": "Jahres-Fotobuch",
        "travel": "Reise-Fotobuch",
        "wedding": "Hochzeits-Fotobuch"
      },
      "add_photos_dialog": {
        "title": "Wo sollen wir deine neuen Fotos platzieren?",
        "add_chronologically": "Chronologisch hinzufügen",
        "add_at_end": "Am Ende hinzufügen"
      },
      "added_in_chronological_order": "In chronologischer Reihenfolge hinzugefügt",
      "arrange": {
        "name": "Anordnen"
      },
      "arrival_notice": {
        "login_title_one": "Willkommen zurück, {{count}} Fotobuch in deinem Warenkorb wiederhergestellt",
        "login_title_other": "Willkommen zurück, {{count}} Fotobücher in deinem Warenkorb wiederhergestellt",
        "title_one": "{{count}} Fotobuch in deinem Warenkorb wiederhergestellt",
        "title_other": "{{count}} Fotobücher in deinem Warenkorb wiederhergestellt"
      },
      "cover": "Cover",
      "cover_edit": {
        "cover_photo_label": "Coverfoto",
        "title": "Cover bearbeiten",
        "title_font_label": "Titel-Schriftart",
        "title_label": "Titel",
        "designed_covers": "Designte Cover",
        "upload": "Hochladen",
        "designs": "Designs",
        "select_cover": "Cover auswählen",
        "crop_and_title_hint": "Zum Zuschneiden zoomen, Titel antippen",
        "ai_cover_create": "Erstellen",
        "ai_cover_title": "Dein Buchtitel",
        "ai_cover_headline_label": "Dein Buchtitel",
        "ai_cover_headline_placeholder": "Dein Buchtitel",
        "ai_cover_generate": "Cover erstellen",
        "ai_cover_retry": "Wiederholen",
        "ai_cover_creating": "Cover wird erstellt",
        "ai_cover_ready_title": "Dein Cover ist fertig",
        "ai_cover_ready_action": "Cover bearbeiten"
      },
      "cover_deep_link": {
        "rejected_title": "Etwas ist schiefgelaufen. Bitte wähle erneut ein Cover"
      },
      "deep_link_photos": {
        "rejected_title": "Etwas ist schiefgelaufen. Füge Fotos hinzu, um dein Buch zu starten"
      },
      "add_text": "Untertitel",
      "creating_book": "Fotobuch erstellen..",
      "default_cover_text": "Glückliche Momente",
      "empty_book": "Das Buch ist noch leer.",
      "title": "Titel",
      "photo": "Foto",
      "ios_uploader": {
        "old_ux_message": "Bitte warte einen Moment, nachdem Du auf \"hinzufügen\" geklickt hast",
        "old_ux_upload": "Fotos hochladen"
      },
      "low_res_photos": {
        "cart_cta": "Prüfen",
        "cart_label": "Fotos mit niedriger Auflösung."
      },
      "not_enough_photos": {
        "cart_cta": "Hinzufügen",
        "cart_label": "Füge noch {{numPhotos}} Fotos hinzu.",
        "cart_title": "Füge mehr Fotos zu deinem Fotobuch hinzu",
        "cta": "Fotos hinzufügen",
        "subtitle": "Du hast weniger als {{totalAmount}} Fotos hochgeladen. Bitte füge mindestens {{missingAmount}} weitere Fotos hinzu, um die Bestellung abzuschließen",
        "title": "Nicht genug Fotos"
      },
      "too_many_pages": {
        "title": "Fast geschafft! Dein Buch ist etwas zu voll",
        "subtitle": "Fotobücher haben Platz für maximal {{maxPhotos}} Fotos. Entferne {{extraPhotos}} Fotos, um dein Buch fertigzustellen.",
        "cta": "Mein Buch bearbeiten"
      },
      "page_1": "Seite 1",
      "page_controls": {
        "adjust_crop": "Zum Anpassen des Zuschnitts zusammenziehen",
        "delete_photo": "Löschen",
        "replace_photo": "Ersetzen",
        "caption_too_long": "Untertitel ist zu lang"
      },
      "page_order": {
        "done": "Fertig",
        "snackbar": {
          "cover_back_cant_edit": "Die Rückseite des Covers kann nicht bearbeitet werden",
          "pages_sorted": "Seiten geordnet",
          "pages_sorted_by_date": "Seiten nach Datum geordnet",
          "undo": "Rückgängig"
        },
        "sort_by_date": "Nach Datum ordnen",
        "sort_confirmation": {
          "approve": "Ordnen",
          "dismiss": "Abbrechen",
          "main_text": "Fotos von ältesten zu neuesten ordnen",
          "title": "Seiten nach Datum ordnen"
        },
        "subtitle": "Verschiebe Fotos, um sie neu anzuordnen",
        "title": "Seitenübersicht",
        "warning": {
          "missing_date": "Markierte Fotos wurden aufgrund fehlender Daten nicht automatisch sortiert. Bitte manuell anordnen"
        }
      },
      "page_range": "Seite {{start}}-{{end}}",
      "page_single": "Seite {{page}}",
      "pages_disabled_message": "Du brauchst mehr Fotos, um die Seiten neu anzuordnen",
      "photo_deleted": "Foto gelöscht",
      "photos_not_uploaded": {
        "title": "{{count}} fotos nicht hochgeladen",
        "subtitle": "Bitte vor dem Bezahlen erneut hinzufügen"
      },
      "photo_limit": {
        "title": "Maximale Anzahl an Fotos erreicht",
        "message": "Maximale Anzahl an Fotos erreicht. Entfernen Sie einige, um weitere hinzuzufügen",
        "subtitle_single": "Bitte entfernen Sie 1 Foto",
        "subtitle_plural": "Bitte entfernen Sie {{v1}} Fotos",
        "all_set": "Alles erledigt! Klicken Sie auf '{{done}}', um fortzufahren"
      },
      "size": "Größe",
      "size_selection": {
        "title": "Buchgröße wählen",
        "select_size": "Größe wählen",
        "page_count": "Seitenzahl",
        "tier_page_range": "{{start}} - {{end}} Seiten",
        "current_tier": "Aktuelle Stufe"
      },
      "swipe_pages": "Umblättern",
      "turn_pages": "Umblättern",
      "updating_book": "Fotobuch aktualisieren...",
      "replacing_photo": "Foto ersetzen...",
      "uploading_photos": "Fotos hochladen"
    },
    "pitch": {
      "copyright": "© Copyright 2015-{{v1}} Mixtiles, LTD",
      "footer": {
        "about": "Über uns",
        "accessibility": "Barrierefreiheit",
        "blog": "Unser Blog",
        "canvas_prints": "Leinwanddrucke",
        "careers": "Karriere",
        "cookie_policy": "Cookie-Richtlinie",
        "facebook": "Facebook",
        "follow_us": "Folge uns",
        "gallery_walls": "Sets",
        "impressum": "Impressum",
        "instagram": "Instagram",
        "join_us": "Komm ins Engineering Team bei Mixtiles",
        "privacy": "Datenschutzerklärung",
        "products": "Produkte",
        "resources": "Ressourcen",
        "terms_of_use": "AGB",
        "twitter": "Twitter",
        "tokushoho": "特定商取引法に基づく表記"
      },
      "footer_links": {
        "accessibility_statement": "Barrierefreiheit",
        "impressum": "IMPRESSUM",
        "privacy_policy": "Datenschutzerklärung",
        "terms_of_use": "AGB",
        "cookie_policy": "COOKIE-RICHTLINIE"
      },
      "global_shipping": "Weltweiter Versand, schnelle Lieferung",
      "headline": "Verwandle Deine Bilder in erschwingliche, umwerfende Wanddeko",
      "icons": {
        "satisfaction": {
          "text": "Nicht happy? Du bekommst Dein Geld zurück!",
          "title": "Mit Zufriedenheitsgarantie"
        }
      },
      "main_button_cta": "Los geht's!"
    },
    "product": {
      "carousel": {
        "adjust_to_perfection": "Passe sie perfekt an ",
        "no_damage": "Sie hinterlassen keine Spuren",
        "peel_stick": "Schutzfolie abziehen und ankleben"
      }
    },
    "product_page": {
      "art_product": {
        "description": "Kunst, die an jeder Wand hält, keine Spuren hinterlässt und umgeklebt werden kann.",
        "description_mobile": {
          "no_nails": "Ganz ohne Nägel. Sie halten an jeder Wand!",
          "satisfaction": "Zufriedenheitsgarantie"
        }
      },
      "choose_your_own_style": "Wähle Deinen eigenen Style",
      "community": {
        "description": "Das sagen unsere Kunden",
        "load_more": "Mehr laden",
        "title": "Aus unserer Community"
      },
      "controls": {
        "art": {
          "browse": "Kunstsammlung anschauen",
          "start": "Kunstdruck hinzufügen"
        },
        "frame_size": "Rahmengröße",
        "frame_style": "Rahmenstil",
        "photobook": {
          "start": "Jetzt Shoppen"
        },
        "tile": {
          "start": "Los gehts!"
        }
      },
      "magnetic_hanging": {
        "description": "Richte Dene Bilder mühelos aus, passe sie an und positioniere sie um. Erfreue Dich an unbeschädigten Wänden und der Freiheit, Deine 4 Wände jederzeit umdekorieren zu können.",
        "title": "Unser magnetisches Aufhängesystem"
      },
      "photobook_product": {
        "beauty": {
          "subtitle": "Jedes Buch hat einen matten Einband und ist auf Premium-Seiten mit seidigem Finish gedruckt",
          "title": "Schönheit auf jeder Seite"
        },
        "bullet_points": {
          "free_shipping": "Kostenlose Lieferung",
          "no_hidden_fees": "Keine versteckten Kosten",
          "same_price": "Der selbe Preis, unabhängig von der Anzahl an Seiten",
          "simple_pricing": "Einfache Preise, keine Überraschungen"
        },
        "description": "Erstelle Dein Buch mit wenigen Klicks und siehe, wie es in 3D zum Leben erweckt wird",
        "description_mobile": {
          "fixed_price": "Fester Preis, unabhängig von den Seiten",
          "quality_book": "Drucke in Museumsqualität, mit einem festen Einband",
          "free_shipping": "Kostenlose Lieferung"
        },
        "title": {
          "default": "Fotobücher leicht gemacht!"
        }
      },
      "price_each": "/Stück",
      "reviews_count": "Mit mehr als 110k App Store Bewertungen",
      "tile_product": {
        "description": "Gerahmte Bilder, die an jeder Wand kleben, ohne Spuren zu hinterlassen und umgeklebt werden können.",
        "description_mobile": {
          "no_nails": "Ganz ohne Nägel. Sie halten an jeder Wand!",
          "satisfaction": "Zufriedenheitsgarantie"
        },
        "tile": "Bild",
        "title": {
          "canvas": "Selbtklebende Leinwanddrucke",
          "regular": "Selbstklebende Fotokacheln"
        }
      },
      "explore": {
        "art": "Kunst Erkunden",
        "canvas_prints": "Leinwanddrucke Erkunden",
        "photo_books": "Fotobücher Erkunden",
        "photo_tiles": "Fotokacheln Erkunden"
      },
      "reviews_count_mobile": "100.000+ Bewertungen"
    },
    "product_selection": {
      "photo_books_name": "Fotobücher",
      "tiles_name": "Bilder",
      "title_choose_what_to_create": "Wähle, was Du erstellen möchtest"
    },
    "rating": {
      "back_to_mixtiles": "Zurück zu Mixtiles",
      "comment": {
        "1-2-stars": {
          "sentence": "Es tut uns so Leid! Möchtest Du uns sagen, was schief gelaufen ist?"
        },
        "3-4-stars": {
          "question": "Was könnten wir dafür tun?",
          "sentence": "Wir würden das gerne besser machen!"
        },
        "5-stars": {
          "question": "Was hat Dir besonders gefallen?",
          "sentence": "Ach, das freut uns aber!"
        }
      },
      "contact_us": "schreib uns.",
      "feel_free": "Falls wir Dir noch irgendwie weiterhelfen können, ",
      "first_question": "Wie hat Dir das Shoppen bei Mixtiles gefallen?",
      "next": "Weiter",
      "star_caption": {
        "1": "Furchtbar",
        "2": "Schlecht",
        "3": "Ok",
        "4": "Gut",
        "5": "Ausgezeichnet"
      },
      "submit": "Abschicken",
      "tell_us_here": "Erzähl's uns (Optional)",
      "thanks": "Danke für Dein Feedback!"
    },
    "refresher_kit_request": {
      "back": "Zurück",
      "back_to_homepage": "Zur Startseite",
      "confirmation": {
        "received_title": "Wir haben Deine Anfrage erhalten!"
      },
      "contact_support": "Support kontaktieren",
      "continue": "Weiter",
      "continue_with_count": "Weiter ({{count}})",
      "errors": {
        "invalid_email": "Bitte gib eine gültige E-Mail-Adresse ein",
        "invalid_state": "Bitte gib ein gültiges Bundesland ein",
        "invalid_submission": "Wir konnten diese Anfrage nicht annehmen. Bitte prüfe Deine Auswahl und Angaben und versuche es erneut.",
        "load_failed": "Ups, da ist etwas schiefgelaufen.",
        "required": "Pflichtfeld",
        "submit_failed": "Wir konnten Deine Anfrage nicht senden. Bitte versuche es erneut."
      },
      "expired": {
        "body": "Kontaktiere unser Support-Team und wir schicken Dir einen neuen.",
        "title": "Dieser Link ist abgelaufen"
      },
      "frame_name": "Rahmen {{v1}}",
      "inactive": {
        "body": "Kontaktiere unser Support-Team und wir helfen Dir weiter.",
        "title": "Dieser Link ist nicht mehr aktiv"
      },
      "invalid_link": {
        "body": "Kontaktiere unser Support-Team und wir helfen Dir weiter.",
        "title": "Dieser Link ist ungültig"
      },
      "no_orders": {
        "body": "Kontaktiere unser Support-Team und wir helfen Dir weiter.",
        "title": "Wir konnten keine zugestellten Bestellungen in diesem Konto finden"
      },
      "select": {
        "title": "Wähle die Bilder aus, die eine Auffrischung brauchen, und erhalte Ersatz-Klebepads"
      },
      "selected_badge": "{{v1}} ausgewählt",
      "selected_of_tiles": "{{v1}}/{{v2}} Bilder",
      "sending": "Deine Anfrage wird gesendet...",
      "shipping": {
        "country": "Land",
        "email": "E-Mail",
        "submit": "Kit anfordern",
        "subtitle": "Deine Ersatz-Klebepads sind für Dich kostenlos.",
        "title": "Wohin sollen wir es schicken?"
      },
      "summary": {
        "adhesives_many": "{{v1}} Ersatz-Klebepads",
        "adhesives_one": "1 Ersatz-Klebepad",
        "title": "Zusammenfassung ({{v1}})"
      },
      "switch_account": "Konto wechseln",
      "tile_count_many": "{{v1}} Bilder",
      "tile_count_one": "1 Bild",
      "try_again": "Erneut versuchen",
      "wrong_account": {
        "body": "Melde Dich mit dem Konto an, an das dieser Link gesendet wurde, oder kontaktiere unser Support-Team.",
        "title": "Dieser Link gehört zu einem anderen Konto"
      }
    },
    "referral": {
      "already_referred": "Du hast bereits einen Empfehlungsgutschein an diese E-Mail-Adresse gesendet. Bitte versuche es mit einer anderen E-Mail-Adresse.",
      "general_error": "Das hat leider nicht geklappt. Bitte versuche es später noch einmal.",
      "login": "Logge Dich ein um fortzufahren",
      "menu_title": "Empfehlungsprogramm",
      "referral_sent": "<div>Der Gutschein ist auf dem Weg zu <b>{{v1}}</b>! <br> Nachdem die beschenkte Person die Bestellung abgeschlossen hat, erhältst Du <b>{{v2}}</b> Mixtiles Guthaben und wirst per E-Mail benachrichtigt. </div>",
      "self_referral": "Du kannst Dir selbst keinen Empfehlungsgutschein senden. Bitte versuche es mit einer anderen E-Mail-Adresse.",
      "send": "Jetzt senden",
      "subtitle": "Für jede Bestellung einer Deiner Freunde, bekommst Du {{v1}} Mixtiles Guthaben - kostenlos!",
      "title": "Verschenke {{v1}}, bekomme {{v1}}"
    },
    "size_selection": {
      "price_per_tile": "{{v1}} pro Bild"
    },
    "wall_designer": {
      "highlighted_tile": {
        "edit_tile": "Kachel bearbeiten",
        "swap_position": "Position tauschen",
        "swap_position_title": "Wähle ein Foto zum Tauschen"
      },
      "photos_selector": {
        "selected": "ausgewählt",
        "title": "{{v1}} Fotos auswählen"
      },
      "preferences_saved": {
        "cta": "Zurück zur Homepage",
        "subtitle": "Wir hoffen, wir sehen Dich ganz bald wieder!",
        "title": "Deine Einstellungen wurden aktualisiert"
      },
      "zoom_button": {
        "full_view": "Gesamtansicht",
        "zoom": "Heranzoomen"
      }
    },
    "wall_feed": {
      "categories": {
        "large": "Groß",
        "medium": "Mittel",
        "small": "Klein"
      }
    },
    "cancel_order_v2": {
      "cta": "Bestellung stornieren",
      "dialog": {
        "title": "Bestellung Stornieren",
        "refund_content": "Du erhältst eine vollständige Rückerstattung von {{sum}}.",
        "refund_refund_info": "Die Rückerstattung wird auf deine ursprüngliche Zahlungsmethode angewendet.",
        "dismiss": "Bestellung behalten"
      }
    },
    "seo": {
      "art": {
        "base": {
          "title": "Kunstwerke von Mixtiles",
          "description": "Verwandle deine Fotos in erschwingliche, beeindruckende Wandkunst"
        }
      },
      "canvas": {
        "base": {
          "title": "Leinwanddrucke von Mixtiles",
          "h1": "Individuelle Foto-Leinwanddrucke",
          "description": "Verwandle deine persönlichen Fotos in beeindruckende Leinwandbilder, die du überall aufhängen kannst — ganz ohne Nägel!"
        },
        "sized": {
          "title": "{{size}} Leinwanddrucke von Mixtiles",
          "h1": "{{size}} Leinwanddrucke",
          "description": "Verwandle deine Fotos in wunderschöne {{size}} Leinwanddrucke — keine Nägel, keine Schäden, nur einfache Wanddekoration."
        }
      },
      "phototiles": {
        "base": {
          "title": "Wiederverwendbare Fotokacheln von Mixtiles",
          "h1": "Wiederverwendbare Fotokacheln",
          "description": "Verwandle deine Fotos in beeindruckende Fotokacheln ohne Nägel oder Schäden an der Wand – mit Mixtiles."
        },
        "sized": {
          "title": "{{size}} Fotokacheln von Mixtiles",
          "h1": "{{size}} Fotokacheln",
          "description": "Verwandle deine Bilder in elegante {{size}} Fotokacheln, die ohne Nägel oder Werkzeuge an der Wand haften."
        },
        "withMaterial": {
          "title": "{{size}} {{frameDisplay}} Fotokacheln von Mixtiles",
          "h1": "{{size}} {{frameDisplay}} Fotokacheln",
          "description": "Verwandle deine Bilder in elegante {{size}} {{frameDisplayLower}} Fotokacheln, die ohne Nägel oder Werkzeuge an der Wand haften."
        }
      },
      "photobooks": {
        "base": {
          "title": "Fotobücher von Mixtiles",
          "h1": "Fotobücher",
          "description": "Erstelle wunderschöne Fotobücher mit Mixtiles. Verwandle deine Erinnerungen in wertvolle Andenken, die ein Leben lang halten."
        },
        "sized": {
          "title": "Fotobuch {{size}} von Mixtiles",
          "h1": "Fotobuch {{size}}",
          "description": "{{description}}"
        },
        "wedding": {
          "title": "Hochzeitsfotobücher von Mixtiles",
          "h1": "Hochzeitsfotobücher",
          "description": "Feiere deine Liebesgeschichte mit Hochzeitsfotobüchern von Mixtiles. Kreiere wunderschöne Alben, erlebe wertvolle Momente neu und genieße Qualität, die ein Leben lang hält.",
          "sized": {
            "title": "Hochzeitsfotobuch {{size}} von Mixtiles",
            "h1": "Hochzeitsfotobuch {{size}}"
          }
        },
        "memory": {
          "title": "Erinnerungsfotobuch von Mixtiles",
          "h1": "Erinnerungsfotobuch",
          "description": "Verwandle deine schönsten Erinnerungen in ein wunderschönes Erinnerungsfotobuch von Mixtiles. Erlebe jeden Moment in atemberaubendem Detail neu!",
          "sized": {
            "title": "Erinnerungsfotobuch {{size}} von Mixtiles",
            "h1": "Erinnerungsfotobuch {{size}}"
          }
        },
        "small": {
          "title": "Kleines Fotobuch von Mixtiles",
          "h1": "Kleines Fotobuch",
          "description": "Zeige die schönsten kleinen Momente des Lebens mit einem kleinen Fotobuch von Mixtiles. Große Erinnerungen, kompakt und schön.",
          "sized": {
            "title": "Kleines Fotobuch {{size}} von Mixtiles",
            "h1": "Kleines Fotobuch {{size}}"
          }
        },
        "boudoir": {
          "title": "Boudoir-Fotobuch von Mixtiles",
          "h1": "Boudoir-Fotobuch",
          "description": "Feiere dein Selbstbewusstsein mit einem Boudoir-Fotobuch von Mixtiles. Ein mutiges, wunderschönes Andenken nur für dich.",
          "sized": {
            "title": "Boudoir-Fotobuch {{size}} von Mixtiles",
            "h1": "Boudoir-Fotobuch {{size}}"
          }
        },
        "travel": {
          "title": "Reisefotobuch von Mixtiles",
          "h1": "Reisefotobuch",
          "description": "Präsentiere deine Abenteuer mit einem Reisefotobuch von Mixtiles. Halte deine Reisen fest, erlebe jeden Trip neu und bewahre deine Erinnerungen immer griffbereit.",
          "sized": {
            "title": "Reisefotobuch {{size}} von Mixtiles",
            "h1": "Reisefotobuch {{size}}"
          }
        },
        "coffee-table": {
          "title": "Coffee-Table-Fotobuch von Mixtiles",
          "h1": "Coffee-Table-Fotobuch",
          "description": "Verleihe deiner Einrichtung Persönlichkeit mit einem Coffee-Table-Fotobuch von Mixtiles. Stil und Erinnerungen in einem perfekten Stück.",
          "sized": {
            "title": "Coffee-Table-Fotobuch {{size}} von Mixtiles",
            "h1": "Coffee-Table-Fotobuch {{size}}"
          }
        },
        "engagement": {
          "title": "Verlobungsfotobuch von Mixtiles",
          "h1": "Verlobungsfotobuch",
          "description": "Halte deine Liebesgeschichte mit einem Verlobungsfotobuch von Mixtiles fest. Ein Andenken, das du für immer schätzen wirst.",
          "sized": {
            "title": "Verlobungsfotobuch {{size}} von Mixtiles",
            "h1": "Verlobungsfotobuch {{size}}"
          }
        },
        "family": {
          "title": "Familienfotobuch von Mixtiles",
          "h1": "Familienfotobuch",
          "description": "Feiere Familienmeilensteine mit einem Familienfotobuch von Mixtiles. Erinnerungen, die du immer wieder gerne teilen wirst.",
          "sized": {
            "title": "Familienfotobuch {{size}} von Mixtiles",
            "h1": "Familienfotobuch {{size}}"
          }
        },
        "anniversary": {
          "title": "Jubiläumsfotobuch von Mixtiles",
          "h1": "Jubiläumsfotobuch",
          "description": "Ehre deine Liebesgeschichte mit einem Jubiläumsfotobuch von Mixtiles. Feiere Jahre voller Erinnerungen auf wunderschöne Weise.",
          "sized": {
            "title": "Jubiläumsfotobuch {{size}} von Mixtiles",
            "h1": "Jubiläumsfotobuch {{size}}"
          }
        },
        "pet-dog": {
          "title": "Hundefotoalbum von Mixtiles",
          "h1": "Hundefotoalbum",
          "description": "Feiere deinen besten Freund auf vier Pfoten mit einem Hundefotoalbum von Mixtiles. Jeder Schwanzwedel, für immer festgehalten.",
          "sized": {
            "title": "Hundefotoalbum {{size}} von Mixtiles",
            "h1": "Hundefotoalbum {{size}}"
          }
        },
        "mothers-day": {
          "title": "Muttertagsfotobuch von Mixtiles",
          "h1": "Muttertagsfotobuch",
          "description": "Schenke deiner Mutter das ultimative Andenken mit einem Muttertagsfotobuch von Mixtiles. Gefüllt mit Liebe, Lachen und Erinnerungen.",
          "sized": {
            "title": "Muttertagsfotobuch {{size}} von Mixtiles",
            "h1": "Muttertagsfotobuch {{size}}"
          }
        },
        "christmas": {
          "title": "Weihnachtsfotobuch von Mixtiles",
          "h1": "Weihnachtsfotobuch",
          "description": "Teile den Zauber der Feiertage mit einem Weihnachtsfotobuch von Mixtiles. Ein Geschenk, das sie Jahr für Jahr schätzen werden.",
          "sized": {
            "title": "Weihnachtsfotobuch {{size}} von Mixtiles",
            "h1": "Weihnachtsfotobuch {{size}}"
          }
        },
        "fathers-day": {
          "title": "Vatertagsfotobuch von Mixtiles",
          "h1": "Vatertagsfotobuch",
          "description": "Zeige deinem Vater, dass er dein Held ist, mit einem Vatertagsfotobuch von Mixtiles. Geschichten, die er für immer bewahren wird.",
          "sized": {
            "title": "Vatertagsfotobuch {{size}} von Mixtiles",
            "h1": "Vatertagsfotobuch {{size}}"
          }
        },
        "retirement": {
          "title": "Ruhestandsfotobuch von Mixtiles",
          "h1": "Ruhestandsfotobuch",
          "description": "Feiere neue Anfänge mit einem Ruhestandsfotobuch von Mixtiles. Erinnerungen an harte Arbeit und wohlverdiente Ruhe.",
          "sized": {
            "title": "Ruhestandsfotobuch {{size}} von Mixtiles",
            "h1": "Ruhestandsfotobuch {{size}}"
          }
        },
        "birthday": {
          "title": "Geburtstagsfotobuch von Mixtiles",
          "h1": "Geburtstagsfotobuch",
          "description": "Verwandle Geburtstagsmomente in bleibende Schätze mit einem Geburtstagsfotobuch von Mixtiles. Jedes Jahr verdient eine Seite!",
          "sized": {
            "title": "Geburtstagsfotobuch {{size}} von Mixtiles",
            "h1": "Geburtstagsfotobuch {{size}}"
          }
        },
        "graduation": {
          "title": "Abschlussfotobuch von Mixtiles",
          "h1": "Abschlussfotobuch",
          "description": "Halte diesen Meilenstein mit einem Abschlussfotobuch von Mixtiles fest. Bewahre all die Momente, die die Reise besonders gemacht haben.",
          "sized": {
            "title": "Abschlussfotobuch {{size}} von Mixtiles",
            "h1": "Abschlussfotobuch {{size}}"
          }
        },
        "yearly": {
          "title": "Jahresfotobuch von Mixtiles",
          "h1": "Jahresfotobuch",
          "description": "Erzähle die Geschichte deines Jahres mit einem Jahresfotobuch von Mixtiles. Jeder Höhepunkt, jede Erinnerung, an einem Ort.",
          "sized": {
            "title": "Jahresfotobuch {{size}} von Mixtiles",
            "h1": "Jahresfotobuch {{size}}"
          }
        },
        "valentines": {
          "title": "Valentinstagsfotobuch von Mixtiles",
          "h1": "Valentinstagsfotobuch",
          "description": "Feiere die Liebe mit einem Valentinstagsfotobuch von Mixtiles. Erinnerungen süßer als Schokolade.",
          "sized": {
            "title": "Valentinstagsfotobuch {{size}} von Mixtiles",
            "h1": "Valentinstagsfotobuch {{size}}"
          }
        },
        "recipe": {
          "title": "Rezeptfotobuch von Mixtiles",
          "h1": "Rezeptfotobuch",
          "description": "Genieße jeden köstlichen Moment mit einem Rezeptfotobuch von Mixtiles. Deine Lieblingsgerichte, für immer griffbereit.",
          "sized": {
            "title": "Rezeptfotobuch {{size}} von Mixtiles",
            "h1": "Rezeptfotobuch {{size}}"
          }
        },
        "deals": {
          "title": "Fotobuch Angebote von Mixtiles",
          "h1": "Fotobuch Angebote",
          "description": "Entdecke fantastische Fotobuch-Angebote bei Mixtiles. Erstelle wunderschöne Fotobücher zu unschlagbaren Preisen und verwandle deine Erinnerungen in bleibende Schätze.",
          "sized": {
            "title": "Fotobuch Angebote {{size}} von Mixtiles",
            "h1": "Fotobuch Angebote {{size}}"
          }
        },
        "designed-covers": {
          "title": "Fotobuch mit gestaltetem Cover von Mixtiles",
          "h1": "Fotobuch mit gestaltetem Cover",
          "description": "Verleih deinem Fotobuch mit gestalteten Covern von Mixtiles den letzten Schliff. Wähle aus wunderschön gestalteten Covern und mach deine Erinnerungen zu einem Schmuckstück zum Vorzeigen.",
          "sized": {
            "title": "Fotobuch mit gestaltetem Cover {{size}} von Mixtiles",
            "h1": "Fotobuch mit gestaltetem Cover {{size}}"
          }
        },
        "baby": {
          "title": "Baby-Fotobuch von Mixtiles",
          "h1": "Baby-Fotobuch",
          "description": "Verwandle das erste Jahr in ein Baby-Fotobuch von Mixtiles. Wähle deine Lieblingsfotos, füge einen Titel hinzu und erhalte ein Buch für hundert Vorlesestunden.",
          "sized": {
            "title": "Baby-Fotobuch {{size}} von Mixtiles",
            "h1": "Baby-Fotobuch {{size}}"
          }
        },
        "wedding-designed-covers": {
          "title": "Hochzeitsfotobuch mit gestaltetem Cover von Mixtiles",
          "h1": "Hochzeitsfotobuch mit gestaltetem Cover",
          "description": "Starte dein Hochzeitsbuch mit einem Cover, das unsere Designer dafür gemacht haben. Wähle deinen Look, füge Fotos hinzu und Mixtiles druckt ein Schmuckstück.",
          "sized": {
            "title": "Hochzeitsfotobuch mit gestaltetem Cover {{size}} von Mixtiles",
            "h1": "Hochzeitsfotobuch mit gestaltetem Cover {{size}}"
          }
        },
        "baby-designed-covers": {
          "title": "Baby-Fotobuch mit gestaltetem Cover von Mixtiles",
          "h1": "Baby-Fotobuch mit gestaltetem Cover",
          "description": "Wähle ein Cover, das für Babyfotos gestaltet wurde, und lass Mixtiles die Seiten mit dem ersten Jahr füllen. Kein Layout nötig, nur Cover und Fotos.",
          "sized": {
            "title": "Baby-Fotobuch mit gestaltetem Cover {{size}} von Mixtiles",
            "h1": "Baby-Fotobuch mit gestaltetem Cover {{size}}"
          }
        },
        "birthday-designed-covers": {
          "title": "Geburtstagsfotobuch mit gestaltetem Cover von Mixtiles",
          "h1": "Geburtstagsfotobuch mit gestaltetem Cover",
          "description": "Pack ein Jahr Geburtstagsfotos in ein Cover, das unsere Designer dafür gemacht haben. Look wählen, Fotos hinzufügen, und Mixtiles macht ein Geschenk daraus.",
          "sized": {
            "title": "Geburtstagsfotobuch mit gestaltetem Cover {{size}} von Mixtiles",
            "h1": "Geburtstagsfotobuch mit gestaltetem Cover {{size}}"
          }
        },
        "coffee-table-designed-covers": {
          "title": "Coffee-Table-Fotobuch mit gestaltetem Cover von Mixtiles",
          "h1": "Coffee-Table-Fotobuch mit gestaltetem Cover",
          "description": "Ein gestaltetes Cover für ein Buch, das sichtbar liegen bleibt. Wähle den Look, füge deine besten Fotos hinzu und Mixtiles gibt ihnen den letzten Schliff.",
          "sized": {
            "title": "Coffee-Table-Fotobuch mit gestaltetem Cover {{size}} von Mixtiles",
            "h1": "Coffee-Table-Fotobuch mit gestaltetem Cover {{size}}"
          }
        },
        "proposal-designed-covers": {
          "title": "Antragsfotobuch mit gestaltetem Cover von Mixtiles",
          "h1": "Antragsfotobuch mit gestaltetem Cover",
          "description": "Halte den Heiratsantrag in einem Buch fest, mit einem Cover, das dafür gestaltet wurde. Look wählen, Fotos vom Tag hinzufügen und das Ja immer wieder erleben.",
          "sized": {
            "title": "Antragsfotobuch mit gestaltetem Cover {{size}} von Mixtiles",
            "h1": "Antragsfotobuch mit gestaltetem Cover {{size}}"
          }
        },
        "christmas-designed-covers": {
          "title": "Weihnachtsfotobuch mit gestaltetem Cover von Mixtiles",
          "h1": "Weihnachtsfotobuch mit gestaltetem Cover",
          "description": "Gib deinen Weihnachtsfotos ein festliches Cover, das unsere Designer für die Saison gestaltet haben. Look wählen, Fotos hinzufügen, jedes Jahr wieder aufschlagen.",
          "sized": {
            "title": "Weihnachtsfotobuch mit gestaltetem Cover {{size}} von Mixtiles",
            "h1": "Weihnachtsfotobuch mit gestaltetem Cover {{size}}"
          }
        },
        "family-designed-covers": {
          "title": "Familienfotobuch mit gestaltetem Cover von Mixtiles",
          "h1": "Familienfotobuch mit gestaltetem Cover",
          "description": "Wähle ein gestaltetes Cover für dein Familienfotobuch und lass Mixtiles aus Alltagsmomenten ein Schmuckstück zum Herumreichen machen.",
          "sized": {
            "title": "Familienfotobuch mit gestaltetem Cover {{size}} von Mixtiles",
            "h1": "Familienfotobuch mit gestaltetem Cover {{size}}"
          }
        },
        "school-years-designed-covers": {
          "title": "Schuljahre-Fotobuch mit gestaltetem Cover von Mixtiles",
          "h1": "Schuljahre-Fotobuch mit gestaltetem Cover",
          "description": "Sammle die Schuljahre in einem Buch mit einem Cover, das dafür gestaltet wurde. Look wählen, Fotos hinzufügen und die Jahre die Seiten füllen lassen.",
          "sized": {
            "title": "Schuljahre-Fotobuch mit gestaltetem Cover {{size}} von Mixtiles",
            "h1": "Schuljahre-Fotobuch mit gestaltetem Cover {{size}}"
          }
        }
      },
      "variant_links": {
        "phototiles_material": "{{frameDisplay}} Bilder"
      }
    },
    "tile_upsell": {
      "centerpiece": {
        "button": "Jetzt gestalten",
        "subtitle": "Nur {{price}}",
        "title": "Füge ein individuelles Schild an deine Wand hinzu"
      },
      "collage": {
        "button": "Jetzt gestalten",
        "subtitle": "{{size}} für {{price}}",
        "title": "Eine Collage deiner Fotos wäre ein tolles Geschenk"
      },
      "referral": {
        "button": "Link teilen",
        "subtitle": "Dieser Link gibt ihnen ${{price}} Rabatt",
        "title": "Hast du Freunde, die Mixtiles lieben würden?"
      },
      "title": "Bestellung abgeschlossen!"
    }
  }
}
